/*globals
 root, grecaptcha, warnOnLeaving:true, tinyMCE, setForSave, Ladda, isMobile,
 start_advancedsearch, removeAdvancedSearch, checkedFourthEmailOption,
 callback, st, stAdmin, startOSAPexport
 */
/*exported
 closeIfOpend, setNettoBrutto, gotoProcess, selectLanguage, selectWebaim,
 toggleUpdategroupOther, toggleCollapse, toggleShowHide, getMediaID3,
 scaleSize, openPopupFilemanager, rgb2hex, pixelToPoint, setAnimationpattern,
 loadSliderstyle, loadSliderstylePattern, generateTaskByForm, generateTaskByid,
 replayTaskByForm, replayTaskById, replaceTask, saveTasks, checkTask1,
 checkTask2, checkTask3, checkTask4, checkTask5, checkTask6, checkTask7,
 checkExamSol, creatreQuestionMediaPopup, setTaskDraggable, setTaskSortable,
 closePopup, requestFullscreenFn, setAnim, setOtherData, callAjax, animate,
 htmlEncode, showDetails, hideDetails, payingShopping, formatNumber, formatString,
 setCoupon, facebookShareCheck, setShoppingSessionData, log, checkSlideChildren,
 */

var filemanagerWindow;
var datacontrollernameFancyBox;
var dataformnameFancyBox;
var datanameFancyBox;
var dataindexFancyBox;
var datatypeFancyBox;
var dataselectedidFancyBox;
var fancyboxParamId;
var fancyboxProcess;

$(document).ready(function () {

    // Workaround Chrome Datatable ColVis button scroll and focus bug
    $("body").on("mouseenter", "ul.ColVis_collection", function(){
        $(this).find("[type=checkbox]").first().click();
        $(this).find("[type=checkbox]").first().click();
    });

    var insertFancyBoxOptions = {
        autoSize : true,
        padding  : 0,
        type     : 'iframe',
        transitionIn: 'elastic',
        transitionOut: 'elastic',
        speedIn: 600,
        speedOut: 600,
        width: '80%'
    };

    $(document).on('click','.insert-new',function(event){
        datacontrollernameFancyBox = $(event.target).closest('.insert-new').data("controller");
        dataformnameFancyBox = $(event.target).closest('form').attr("id");
        var controller = $(event.target).closest('.insert-new').data("controller").replace(/\d+/,'');
        datanameFancyBox = $(event.target).closest('.insert-new').data("id");
        datatypeFancyBox =  $(event.target).closest('.insert-new').data("type");
        dataselectedidFancyBox =  $(event.target).closest('.insert-new').data("selectedid");
        fancyboxParamId = $(event.target).closest('.insert-new').data("paramid");
        fancyboxProcess = $(event.target).closest('.insert-new').data("process");
        //alert (fancyboxProcess);

        var params = $(event.target).closest('.insert-new').data("params");
        params = params !== undefined ? params : "";
        var furtherOpts =  $(event.target).closest('.insert-new').data("fancy-opts") ? jQuery.parseJSON(decodeURIComponent($(event.target).closest('.insert-new').data("fancy-opts"))) : "" ; // example: _view/modul_getembedded_view.php - fancyOpts

        dataindexFancyBox = $(event.target).closest('.insert-new').data("index");
        var opts = $.extend({}, insertFancyBoxOptions, {
            href: root+'admin/'+controller+'/insert?menutop=no&header=no&menubottom=no&websiteleft=no&websiteright=no&footer=no&fancy=yes&fn=updateinsert'+params,

        },furtherOpts);
        $.fancybox.open(opts);
    });

    // Make sure links meant to point inside the page really point inside the page despite the <base> tag
    $('a[href^=#]:not(.bhoechie-tab-menu a)').each(function(){
        var $this = $(this);
        var href = $this.attr('href');
        if(href.length > 1) $this.attr('href', location.pathname + href);
    });

    $(".disablePaste").live('input paste', function (e) {
        e.preventDefault();
    });

    $(".tinymcebutton").click(function () {
        tinyMCE.triggerSave();
    });

    $(".ajaxbutton").click(function (event) {

        event.preventDefault();

        if($(this).data("needconfirm") && !$(this).data("confirmed")) {
            window[$(this).data("needconfirm")]();
            return false;
        }

        var spinnerColorMissing = !$(this).is('[data-spinner-color]');
        var requestsSpinnerSizeFromFont = $(this).is('[data-spinner-size=font]');
        if(spinnerColorMissing || requestsSpinnerSizeFromFont) {
            var style = getComputedStyle(this);

            if(spinnerColorMissing) {
                $(this).attr({'data-spinner-color': style.color});
            }

            if(requestsSpinnerSizeFromFont) {
                $(this).attr({'data-spinner-size': style.fontSize});
            }
        }
        var circle = Ladda.create(this);
        if ($(this).hasClass("setforsave")) {
            setForSave();
        }
        if($(this).data("beforesubmit")) window[$(this).data("beforesubmit")]();
        var elementId = $(this).attr("id");
        // var formName = typeof(elementId) === "string" ? elementId.replace("submit", "") : null;
        submitForm(circle, $(this).closest("form"), $(this).attr("ajaxurl"), $(this).data("ajax-callbackparam"), this);
        return false;

    });

    $(".deletefromcartbutton").click(function (e) {
        e.preventDefault();
        var circle = Ladda.create(this);

        deleteFromCart(circle, $(this).attr("id").replace("deletefromcart_", ""), $(this).attr("sure"));
        return false;
    });

    // $(".selectpicker").selectpicker({
    //     size: 5
    // });

    $('.btn-toggle').click(function () {
        $(this).find('.btn').toggleClass('active');

        if ($(this).find('.btn-primary').size() > 0) {
            $(this).find('.btn').toggleClass('btn-primary');
        }
        if ($(this).find('.btn-danger').size() > 0) {
            $(this).find('.btn').toggleClass('btn-danger');
        }
        if ($(this).find('.btn-success').size() > 0) {
            $(this).find('.btn').toggleClass('btn-success');
        }
        if ($(this).find('.btn-info').size() > 0) {
            $(this).find('.btn').toggleClass('btn-info');
        }

        $(this).find('.btn').toggleClass('btn-default');

    });

    $("[data-toggle='tooltip']").tooltip();
    $('.selectpicker[data-id="selectlanguage"]').attr("title", "");
    $('.selectpicker[data-id="slideelementtemplate"]').attr("title", "");

    // Datatable show icons
    if ($(".admin").length) {
        if ($("#datatable").length) {
            var hide = true;
            $(document).scroll(function () {
                if($("#datatable").closest(".div-container").length > 0) {
                    // the table is hidden
                    if($("#datatable").closest(".div-container").hasClass("hide")) {
                        $(".datatable_head2_fix").remove();
                        return;
                    }
                }
                var tableTop = $("#datatable").offset().top;
                var tableBottom = $("#datatable").offset().top + $('#datatable').outerHeight(true);

                if ($(this).scrollTop() >= tableTop && $(this).scrollTop() <= tableBottom) {
                    if (hide) {
                        $(".datatable_head2").clone(true, true).prependTo("body").removeClass("datatable_head2").addClass("datatable_head2_fix");
                        $(".datatable_head2_fix").css("display", "none");
                        $(".datatable_head2_fix img").attr("width", "40");
                        $(".datatable_head2_fix img").attr("height", "40");
                        $(".datatable_head2_fix").fadeIn(300);
                        hide = false;
                    }
                } else {
                    if (!hide) {
                        $(".datatable_head2_fix").fadeOut(300, function () {
                            $(".datatable_head2_fix").remove();
                        });
                    }
                    hide = true;
                }
            });
        }
    }

    // up and dow arrows
    $('#nav_down').click(
        function () {
            $('html, body').animate({scrollTop: $("body").height()}, 1000);
        }
    );
    $('#nav_up').click(
        function () {
            $('html, body').animate({scrollTop: '0'}, 500);
        }
    );

    // Show or hide arrows
    setNavigationArrows();
    $('body').click(function () {
        setNavigationArrows();
    });

    var $fixedsticky = $('.fixedsticky');
    if($fixedsticky.length) {
        if($.fn.fixedsticky) {
            $fixedsticky.fixedsticky();
        } else {
            console.log('Warning: JQuery fixedsticky plugin is not available. (Please load plugin script!)');
        }
    }

    initSlideshow();

    initSpecialIframes();

	//time required open
    $(document).on("click", '.timerequired-display-container[data-url], .timerequired-plus-container[data-url], #datatable td .timerequired-plus-container[data-url]', function(event)
    {
		event.preventDefault();
		window.open(
			$(this).data("url"),
			'_blank'
		);
		return false;
	});

    var timeTreesDP = [];
    function initTimerequiredTrees()
    {
        var $data = $(".modul-timerequired").find("ul");
        $.each($data, function (i, v)
        {
            timeTreesDP[i] =
            {
                parent: $(this).data("parent"),
                element: $(v),
                open: $(v).data("open")
            };
        });
    }
    window.initTimerequiredTrees = initTimerequiredTrees;

    /**
     * This function is toggle the timerequired tree elements
     */
    $(document).on("click", ".timerequired-courses-icondiv, .timerequired-chapters-icondiv, .timerequired-lessons-icondiv", function ()
    {
        var id = $(this).data("id");
        $.each(timeTreesDP, function(i, v)
        {
            if (v.parent == id)
            {
                if(v.open)
                {
                    $(v.element).hide();
                    v.open = 0;
                }
                else
                {
                    $(v.element).show();
                    v.open = 1;
                }
            }
        });
    });

    /**
     * This function open a tree on Course progress by param (co, ch, le)
     * @param {string} param
     */
    function openTree(param, button)
    {
        var $button = $(button);
        var buttonOpen = $button.data("open");
        if (param == "le")
        {
            if (!$("#tree-opener-course").data("open"))
            {
                openTree('co', $("#tree-opener-course"));
            }
            if (!$("#tree-opener-chapter").data("open"))
            {
                openTree('ch', $("#tree-opener-chapter"));
            }
        }
        if (param == "ch") {
            if (!$("#tree-opener-course").data("open"))
            {
                openTree('co', $("#tree-opener-course"));
            }
        }
        $.each(timeTreesDP, function(i, v)
        {
            if (v.parent != undefined)
            {
                if (v.parent.indexOf(param) !== -1)
                {
                    if (buttonOpen)
                    {
                        $(v.element).hide();
                        v.open = 0;

                    }
                    else
                    {
                        $(v.element).show();
                        v.open = 1;
                    }
                }
            }
        });

        if(buttonOpen)
        {
            $button.data("open", 0);
        }
        else
        {
            $button.data("open", 1);
        }
    }
    window.openTree = openTree;

    /**
     * This function is initialize the popovers
     */
    $(function () {
      $('[data-toggle="popover"]').popover();
    });

	//resend activation email
	$(document).on("click","#resendemail", function(e)
    {
		var url = $(this).attr("ajaxurl");
		e.preventDefault();
		var circle = Ladda.create(this);
		circle.start();
		var formData;

        formData = new FormData();
		var username = $("#username").val();

		if(username == undefined)
		{
			username = $("#loginusername").val();
		}
		formData.append("username",username);

		$.ajax({
			cache: false,
			contentType: false,
			processData: false,
			url: root+"ajax/"+url,
			type: 'POST',
			data: formData,
			success:  function responseAjax(datas){
				var data = $.parseJSON(datas);

				if(data.errors)
				{
					$("#loginform div[id*='error_']").each(function(index, element)
					{
					$(this).addClass("hide").removeClass("show");
					if((data[$(this).attr("id")] != undefined)&&(data[$(this).attr("id")] != ""))
					{
						if($(this).find(".errortext").hasClass( "alert" )) {
						$(this).find(".errortext").html(data[$(this).attr("id")]);
						$(this).addClass("show").removeClass("hide", setTimeout(function(){ $('#error_login').fadeOut("slow", function() { $('#error_login').removeClass("show"); }); }, 4000));
						} else {
						$(this).find(".errortext").html(data[$(this).attr("id")]);
						$(this).addClass("show").removeClass("hide");
						}

					}
					});

					$("#registrationform div[id*='error_']").each(function(index, element)
					{
					$(this).addClass("hide").removeClass("show");
					if((data[$(this).attr("id")] != undefined)&&(data[$(this).attr("id")] != ""))
					{
						if($(this).find(".errortext").hasClass( "alert" )) {
						$(this).find(".errortext").html(data[$(this).attr("id")]);
						$(this).addClass("show").removeClass("hide", setTimeout(function(){ $('#error_login').fadeOut("slow", function() { $('#error_login').removeClass("show"); }); }, 4000));
						} else {
						$(this).find(".errortext").html(data[$(this).attr("id")]);
						$(this).addClass("show").removeClass("hide");
						}

					}
					});

				} else if(data.error_db != ""){

				alertDialog(data.error_db);

				} else {

				$("#error_form").addClass("hide").removeClass("show");
				$("#error_login").addClass("hide").removeClass("show");
				$("#registrationform").hide();
				$("#end").show();
				if(data.succes)
				{
					$("#msg").append(data.succes_keycode+data.succes_organisations+data.succes_usergroups+data.succes_courses);
				}
				}
				circle.stop();
			},
			error: function(jqXHR, status, error)
			{
				if( typeof grecaptcha == "object" ) grecaptcha.reset();
				circle.stop();
				alertDialog("Status: "+status+" Error: "+error);
			}
		});
	});

    // delete title of selectpickers
    $.fn.selectpicker_remove_title = function() {
        $(this).next().children().removeAttr('title');
    };

    remove_title_from_selectpicker();

    /* FORM PANEL COLLAPSE OPEN - CLOSE ALL */

    $(".collapse-open-colse-all").find(".panel-close-all").on("click", function () {
        $(".form-panel-collapse").each(function (i, element) {
            $(this).collapse("hide");
        });
    });

    $(".collapse-open-colse-all").find(".panel-open-all").on("click", function () {
        $(".form-panel-collapse").each(function(i,element){
            $(this).collapse("show");
        });
    });

    /* TC CARDS OPEN - CLOSE */

    $(".card .valign .opener, .card .valign .closer").on("click", function () {
        var card = $(this).parent(".valign").parent(".card-reveal").parent(".card");
        if ($(card).find(".card-more-info").data("open") == "0")
        {
            $(this).addClass("hide");
            $(card).find(".closer").removeClass("hide");
            $(card).find(".card-more-info").slideDown("fast");
            $(card).find(".card-more-info").data("open", "1");
        }
        else if ($(card).find(".card-more-info").data("open") == "1")
        {
            $(this).addClass("hide");
            $(card).find(".opener").removeClass("hide");
            $(card).find(".card-more-info").slideUp("fast");
            $(card).find(".card-more-info").data("open", "0");
        }
    });

    $(".card .card-image").on("click", function () {
        var card = $(this).parent(".card");
        $(card).children(".card-reveal").children(".valign").children(".opener").addClass("hide");
        $(card).children(".card-reveal").children(".valign").children(".closer").removeClass("hide");
        $(card).find(".card-more-info").slideDown("fast");
        $(card).find(".card-more-info").data("open", "1");
    });

    autosizeBootstapToggles();

    /* FancyBox gallery initialisation */
    if(typeof(jQuery().fancybox)==='function') {
        $(".fancybox-imageviewer")
        .attr('rel', 'gallery')
        .fancybox({
            padding : 0
        });
    }
});

/**
 * Run advanced search automatically if url has 'as', 'v', 'col' and 'con' params.
 */
function runAdvancedSearchFromUrlParams() {
    if(window.location.pathname.indexOf("admin") != -1 && window.location.search.length > 0) {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var advancedSearch = urlParams.get('as');
        var columnFilter = urlParams.get('columnfilter');
        if(advancedSearch == "true") {
            var value = decodeURIComponent(urlParams.get('v'));
            var col = decodeURIComponent(urlParams.get('col'));
            var con = decodeURIComponent(urlParams.get('con'));
            if(value.length > 0 && col.length > 0 && con.length > 0) {
                $("#advancedSearchContent .advancedSearchTable .advancedSearchLine").remove();
                $("#advancedSearchContent #advancedsearch_ids").val("");
                advancedsearch_addcondition("remove");
                advancedsearch(value,col,con);
                window.history.replaceState(null, null, window.location.pathname); // remove window.location.search
            }
        }
        if(columnFilter == "true") {
            var value = decodeURIComponent(urlParams.get('v'));
            var col = decodeURIComponent(urlParams.get('col'));
            if(value.length > 0 && col.length > 0) {
                $.each($("input[data-db-field]"), function (i,v) {
                    $(v).val("");
                    $(v).keyup();
                })
                $("input[data-db-field="+col+"]").val(value);
                $("input[data-db-field="+col+"]").keyup();
                window.history.replaceState(null, null, window.location.pathname); // remove window.location.search
            }
        }
    };
}

/**
 * Resizes bootstrapToggle buttons to best fit.
 * Processes only <input type="checkbox" data-toggle="toggle" data-width="auto"> elements.
 * Solves autosize problem, when toggle button is not visible upon initialization.
 */
function autosizeBootstapToggles() {
    var $toggles = $('input[type="checkbox"][data-toggle="toggle"][data-width="auto"]');

    if(!$toggles.length) return;

    var $container =
        $('<div />')
        .css({
            position: 'absolute',
            top: 0,
            left: 0,
            visibility: 'hidden'
        })
        .appendTo('body');

    $toggles.each(function(index, element) {
        $container.empty();

        var width = 0;
        var $toggle = $(element).closest('.toggle');
        var $toggleClone = $toggle.clone().appendTo($container);

        $toggleClone
        .find('.toggle-group label')
        .css({width: 0})
        .each(function(index, label) {
            width = Math.max(width, $(label).outerWidth() + label.scrollWidth);
        });

        if(width > 0) $toggle.css({width: width + 'px'});
    });

    $container.remove();
}

function remove_title_from_selectpicker() {
    $(".selectpicker").each(function () {
        var element_id = $(this).attr("id");
        if (element_id != undefined) {
            if (element_id.indexOf("#") == -1) {
                var $sel = $("#" + element_id).selectpicker();
                $sel.selectpicker_remove_title();
                $sel.change($.fn.selectpicker_remove_title);
            }
        }
    });
}

/** Initializes slideshows on page. */
function initSlideshow() {
    var $containers = $('.slideshow');
    if(!$containers.length) return;

    var DEFAULT_DELAY = 5000;

    var imgQueue = {};

    $containers.each(function(index, container) {
        var $container = $(container);

        if($container.data('initdone')) return;
        $container.data({initdone: true});

        var $children = $container.children();

        $children.filter(':not(li)')
        .wrap('<div class="slideshow-item"/>');

        $children.filter('li')
        .addClass('slideshow-item');

        $children.each(function(index, element){
            var $child = element.tagName == 'LI' ? $(element).children(':first') : $(element);
            var title = $child.data('title') || $child.attr('title') || $child.attr('alt');
            if(title != null && title != '') {
                var $title = $('<div class="slideshow-title"/>').text(title);
                $child.after($title);
            }
        });

        var $imgs = $container.find('img');

        $imgs.each(function(index, img) {
            if(imgQueue[img.src]) return;

            var image = new Image();
            imgQueue[img.src] = image;
            $(image)
            .one('load error', onSlideshowImageDone)
            .prop({src: img.src});
        });

        if(!$imgs.length) startSlideshow();

    });


    /**
     * Handles image load and error events.
     * @param {Event} event
     */
    function onSlideshowImageDone(event) {
        var image = event.target;
        if(event.type == 'error') {
            console.log('Error loading image "' + image.src + '".');
        }
        delete imgQueue[image.src];
        if($.isEmptyObject(imgQueue)) startSlideshow();
    }

    /**
     * Starts the slideshows on page.
     */
    function startSlideshow() {
        console.log('Starting ' + $containers.length + ' slideshow(s).');

        $containers.each(function(index, container) {
            var $container = $(container);
            $container.height($container.children(':visible').height());
            startSlideshowTimer(container);
        });
    }

    /**
     * Starts a slideshow timer for a container.
     * @param JQuery container - The jQuery selector for the container.
     */
    function startSlideshowTimer(container) {
        var $container = $(container);
        var delay = parseInt($container.data('delay')) || DEFAULT_DELAY;
        setTimeout(nextSlideshowElement, delay, container);
    }

    /**
     * Displays the next slideshow element in a container.
     * @param JQuery container - The jQuery selector for the container.
     */
    function nextSlideshowElement(container) {
        var $children = $(container).children();
        var $current = $children.filter(':visible');
        var nextIndex = ($current.index() + 1) % $children.length;
        var $next = $($children.get(nextIndex));
        $next
        .css({zIndex: 1, display: 'none', position: 'absolute', top: 0, left: 0})
        .fadeIn(1000, function(){
            $current.css({display: 'none'});
            $next.css({zIndex: '', position: '', top: '', left: ''});
            startSlideshowTimer(container);
        });
        $(container).height($next.height());
    }

}

function initSpecialIframes() {
    $('iframe[data-src]').each(function (index, iframe) {
        var $iframe = $(iframe);
        var url = $iframe.attr('data-src');

        var baseUrlParts = url.split('/');
        baseUrlParts.splice(baseUrlParts.length - 1, 1);
        var baseUrl = baseUrlParts.join('/');

        var baseParts = location.href.split('/');
        baseParts[baseParts.length - 1] = baseUrl;

        var baseHref = baseParts.join('/');
        if (baseHref.substr(-1) != '/') baseHref += '/';

        $.ajax({
            dataType: "HTML",
            cache: false,
            url: url,
            error: function (x, status, error) {
                console.log("Status: " + status + " Error: " + error);
            },
            success: function responseAjax(html) {
                html = html.replace('<head>', '<head><base href="' + baseHref + '">');
                var doc = $iframe[0].contentWindow.document;
                doc.open();
                doc.write(html);
                doc.close();
            }
        });
    });
}

function setNavigationArrows() {
    setTimeout(function () {
        if ($("html").get(0).scrollHeight <= $(window).height()) {
            $("#nav_up_and_down_container").css({display: "none"});
        } else {
            $("#nav_up_and_down_container").css({display: "block"});
        }
    }, 500);
}

function closeIfOpend() {
    if (window.opener && typeof(window.opener.callback) === "function") {
        window.close();
    }
}

/*
 function setMenuCookie(id)
 {
 if($("#"+id).next("div").hasClass("in")){
 $.cookie(id, "true", {path:'/'});
 } else {
 $.cookie(id, "false", {path:'/'});
 }
 }
 */

function setNettoBrutto(taxid, nettoid, bruttoid, currencyid, type) {

    var tax = parseInt($("#" + taxid).find(':selected').attr('data-value'));

    var taxvalue = $("#" + taxid).find(':selected').attr('value');

    var netto = parseFloat($("#" + nettoid).val());
    var brutto = parseFloat($("#" + bruttoid).val());

    if(!netto){
        netto = 0;
    }

    if(!brutto){
        brutto = 0;
    }

    var decimal = parseInt($("#" + currencyid).find(':selected').data('decimal'));

    var currencyval = $("#" + currencyid).find(':selected').attr('value');

    var newnetto = "";
    var newbrutto = "";

    if(tax != 0) {
        newnetto = (brutto / (1 + (tax / 100))).toFixed(decimal);
        newbrutto = ((1 + (tax / 100)) * netto).toFixed(decimal);

        if ((type == "netto" && tax) || (type == "tax" && netto)) {
            $("#" + bruttoid).val(newbrutto);
        }
        if ((type == "brutto" && tax) || (type == "tax" && brutto && !netto)) {
            $("#" + nettoid).val(newnetto);
        }

    } else {

        if(type == "netto"){
            newbrutto = (netto).toFixed(decimal);
            newnetto = newbrutto;
        }else if(type == "brutto"){
            newnetto = (brutto).toFixed(decimal);
            newbrutto = newnetto;
        } else {
            newnetto = (brutto).toFixed(decimal);
            newbrutto = newnetto;
        }

        $("#" + bruttoid).val(newbrutto);
        $("#" + nettoid).val(newnetto);

    }

    if (type == "currency") {
        var s;
        if (decimal == 0) {
            s = 1;
        } else if (decimal == 1) {
            s = 0.1;
        } else if (decimal == 2) {
            s = 0.01;
        } else {
            s = 1;
        }

        $("#" + nettoid).trigger("touchspin.updatesettings", {decimals: decimal, step: s});
        $("#" + bruttoid).trigger("touchspin.updatesettings", {decimals: decimal, step: s});
    }

    if($("#trainingconstitutionarea").length) {

        if ($("#installment_price_1").length) {
            $("#installment_price_1").val($("#" + bruttoid).val());
        }

        if ($("#orig_netto").length) {
            if ($("#" + nettoid).val() != $("#orig_netto").val()) {
                checkedFourthEmailOption({"netto": 1});
            } else {
                checkedFourthEmailOption({"netto": 2});
            }
        }
        if ($("#orig_brutto").length) {
            if ($("#" + bruttoid).val() != $("#orig_brutto").val()) {
                checkedFourthEmailOption({"brutto": 1});
            } else {
                checkedFourthEmailOption({"brutto": 2});
            }
        }

        if ($("#orig_tax").length) {
            if (taxvalue != $("#orig_tax").val()) {
                checkedFourthEmailOption({"tax": 1});
            } else {
                checkedFourthEmailOption({"tax": 2});
            }
        }

        if ($("#orig_currency").length) {
            if (currencyval != $("#orig_currency").val()) {
                checkedFourthEmailOption({"currency": 1});
            } else {
                checkedFourthEmailOption({"currency": 2});
            }
        }
    }

}

/**
 * Returns form data as object
 * @return {object} The form data
 */
jQuery.fn.serializeObject = function serializeObject() {
    // Original concept by Tobias Cohen and Daniel X Moore
    // http://stackoverflow.com/questions/1184624/convert-form-data-to-javascript-object-with-jquery#5199982
    var arrayData, objectData;
    arrayData = this.serializeArray();
    objectData = {};

    $.each(arrayData, function() {
        var value = this.value != null ? value = this.value : '';

        if (objectData[this.name] != null) {
            if (!$.isArray(objectData[this.name])) objectData[this.name] = [objectData[this.name]];
            objectData[this.name].push(value);
        } else {
            objectData[this.name] = value;
        }
    });

    return objectData;
};

function submitForm(circle, form, url, callbackparam, button, formprocessid) {
    circle.start();

    if(typeof formprocessid === "undefined"){
        formprocessid = '';
    }

    //console.log(form);
    var $form = typeof form === "string" ? $("form#" + form) : $(form);
    var formID = $form.attr("id");
    var formData, useCache, useContentType, useProcessData;
    var attr = $form.attr("enctype");
    var buttonData = $(button).data() || {};
    var confirmText = buttonData.confirmationtext || stAdmin.CONFIRM_EMAILSEND;
    var confirmTextYes = buttonData.yestext || stAdmin.DIALOG_YES;
    var confirmTextNo = buttonData.notext || stAdmin.DIALOG_NO;
    var confirmTextAlertType = buttonData.confirmationtextalerttype || "info";
    var onSubmitCallback = buttonData.onsubmitcallback;
    var callback = buttonData["ajax-callback"];
    var multiupdate = 0;
    if(buttonData.hasOwnProperty('multiupdate') && buttonData.multiupdate == 1){
        multiupdate = 1;
        initMultiUpdateProgressBar()
    }

    if (typeof attr !== typeof undefined && attr !== false) {

        formData = new FormData();
        formData.append('multiupdate', multiupdate);
        formData.append('formprocessid', formprocessid);

        jQuery.each($(".uploadfiles"), function () {
            var inputid = $(this).attr("id");
            var multiple = $(this).prop("multiple");
            if(multiple) {
                jQuery.each($(this)[0].files, function (i, file) {
                    formData.append(inputid+"[]", file);
                });
            } else {
                jQuery.each($(this)[0].files, function (i, file) {
                    formData.append(inputid, file);
                });
            }

        });

        var excludeSelector = $form.data('exclude');
        var fields = excludeSelector == undefined ? $form.serializeArray() : $form.find('input,textarea,select,button').not(excludeSelector).serializeArray();
        jQuery.each(fields, function (i, field) {
            formData.append(field.name, field.value);
        });

        useCache = false;
        useContentType = false;
        useProcessData = false;

    } else {
        formData = $form.serialize();
        formData += '&multiupdate='+multiupdate;
        if(formprocessid){
            formData += '&formprocessid='+formprocessid;
        }
        useCache = true;
        useContentType = "application/x-www-form-urlencoded; charset=UTF-8";
        useProcessData = true;

    }

    var f = null;
    if($form.attr("data-json") == "true") {
        f = $form.serializeObject();
        f.multiupdate = multiupdate;
        f.formprocessid = formprocessid;
        formData = {
            json: JSON.stringify(f)
        };
        useCache = true;
        useContentType = "application/x-www-form-urlencoded; charset=UTF-8";
        useProcessData = true;
    }

    $.ajax({
        cache: useCache,
        contentType: useContentType,
        processData: useProcessData,
        type: "POST",
        url: root + "ajax/" + url,
        data: formData,
        error: function (x, status, error) {
            if (typeof grecaptcha == "object") grecaptcha.reset();
            circle.stop();
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            if (typeof grecaptcha == "object") grecaptcha.reset();
            var data = $.parseJSON(datas);

            var defer = false;
            if(typeof(window[onSubmitCallback])==='function') {
                var formSuccess = data && !data.errors;
                defer = window[onSubmitCallback](formSuccess, f || $form.serializeObject(), __continue);
            }

            if(!defer) __continue();

            function __continue() {
                circle.stop();
                if (data.errors) {

                    if(multiupdate){
                        resetMultiUpdateProgressBar()
                    }

                    if(formID != "loginform" && url != "login/login"){
                        $(".form-block-panel").addClass("panel-default").removeClass("panel-danger");
                    }

                    $form.find("div[id*='error_']").each(function (index, element) {
                        $(this).addClass("hide").removeClass("show");
                        if ((data[$(this).attr("id")] != undefined) && (data[$(this).attr("id")] != "")) {

                            $(this).closest(".collapse-form-block-group").find(".form-block-panel").addClass("panel-danger").removeClass("panel-default");
                            $(this).addClass("alert-danger");

                            if ($(this).find(".errortext").hasClass("alert")) {
                                $(this).find(".errortext").html(data[$(this).attr("id")]);
                                $(this).addClass("show").removeClass("hide", setTimeout(function () {
                                    $('#error_login').fadeOut("slow", function () {
                                        $('#error_login').removeClass("show");
                                    });
                                }, 4000));
                            } else {
                                $(this).find(".errortext").html(data[$(this).attr("id")]);
                                $(this).addClass("show").removeClass("hide");
                            }
                        }
                    });

                    $(".collapse-form-block-group .form-block-panel.panel-danger .form-panel-collapse").collapse('show');
                    if(formID != "loginform" && url != "login/login"){
                        $(".collapse-form-block-group .form-block-panel.panel-default .form-panel-collapse").collapse('hide');
                    }

                    $form.find("li[id*='tab_']").each(function (index, element) {
                        $(this).removeClass("danger");
                        var $tab = $(this);
                        var tabId = $tab.attr("id");
                        if (data["error_" + tabId]) {
                            $tab.addClass("danger");
                        } else {
                            $tab.closest("ul").next('.tab-content').find('.tab-pane').eq($tab.index()).find('input[type=text],textarea').each(function(index, element) {
                                var elementId = $(element).attr("id");
                                if (data["error_" + elementId]) {
                                    $tab.addClass("danger");
                                    return false;
                                }
                            });
                        }
                    });

                    if($.fancybox && $.fancybox.isActive) $.fancybox.update();

                } else if (data.error_db != "") {

                    alertDialog(data.error_db);

                } else {

                    if(data.hasOwnProperty("emailConfirmation") && data.emailConfirmation)
                    {
                        var nl2br = (data.hasOwnProperty("nl2br") && data.nl2br) ? true : false;
                        confirmDialog(confirmText, confirmTextYes,confirmTextNo, function () {
                            $("#confirmed").val("1");
                            $(button).click();
                        }, null, null, null, confirmTextAlertType, nl2br);
                    }
                    else
                    {
                        //trigger an event when the from save is success
                        $(document).trigger(formID+'-saved',[data]);

                        if(getUrlParameter("fancy") == "yes") {

                            if (data.url == "opennewtab") {
                                // qnr virtualclassroom open
                                if (data.open_url.indexOf("http") !== 0) {
                                    data.open_url = root + data.open_url;
                                }
                                window.parent.$(".fancybox-overlay").css("display","none");
                                setTimeout(function() {
                                    window.open(data.open_url,'_blank');
                                    window.parent.$.fancybox.close();
                                },100);

                            } else {
                                // everything else
                                var fgv = getUrlParameter("fn");
                                window.parent.$.fancybox.close();

                                if(window.parent[fgv] && $.isFunction(window.parent[fgv])){
                                    window.parent[fgv](data);
                                }
                            }
                        } else {

                            if (typeof(warnOnLeaving) == 'boolean') warnOnLeaving = false;

                            // if multi update then set the progress bar and submit form again
                            if(multiupdate){
                                if(!data.hasOwnProperty('percent') || !data.hasOwnProperty('formprocessid')) return console.error('Missing configurations in the multiprocess update. (percent, formprocessid)', data);
                                setMultiUpdateProgressBar(data.percent)
                                if(data.percent<100){
                                    return submitForm(circle, form, url, callbackparam, button, data.formprocessid)
                                }
                            }

                            if (callbackparam && typeof(callback) === "function") {
                                callback(data,callbackparam);
                            }
                            if (callbackparam && window.opener && typeof(window.opener.callback) === "function") {
                                window.opener.callback(callbackparam, data);
                                window.close();
                            }


                            if (data.url == "self") {
                                if (url == 'login/logout' && location.pathname.indexOf('/shopping') >= 0) {
                                    location.href = root;
                                } else {
                                    location.reload();
                                }
                            } else if(data.url == "logout" && location.href.startsWith(root + 'admin/')) {
                                location.href = root;
                            } else if (data.url == "showend") {
                                $form.hide();
                                $("." + $("#end").data("hide-class")).hide();
                                $("#end").show();

                                if ($("#end").hasClass("locationreload")) {
                                    setTimeout(window.location.reload.bind(window.location), $("#end").attr("data-reload"));
                                }

                                if ($("#end").attr("data-reload-url")) {
                                    setTimeout(function() {
                                        location.href = $("#end").attr("data-reload-url");
                                    }, $("#end").attr("data-reload"));
                                }
                                // if ($("#end").hasClass("showmytrainingcourse")) {
                                //     if(typeof data.url2 != "undefined" && data.url2) {
                                //         location.href = data.url2;
                                //     } else {
                                //         setTimeout(window.location.reload.bind(window.location), $("#end").attr("data-reload"));
                                //     }
                                // }

                            } else if (data.url.substr(0, 5) == "show:") {
                                $form.hide();
                                var $item = $(data.url.substr(5));
                                $item.removeClass('hide').show();
                                if ($item.hasClass("locationreload")) {
                                    setTimeout(window.location.reload.bind(window.location), $item.attr("data-reload"));
                                }
                            } else if (data.url == "opennewtab") {

                                if (data.open_url.indexOf("http") !== 0) {
                                    data.open_url = root + data.open_url;
                                }
                                window.open(data.open_url,'_blank');


                                if (data.location_url.indexOf("http") !== 0) {
                                    data.location_url = root + data.location_url;
                                }
                                location.href = data.location_url;


                            } else if (data.url != "") {
                                if (data.url.indexOf("http") === 0) {
                                    location.href = data.url;
                                } else {
                                    location.href = root + data.url;
                                }
                            }
                            if (data.scriptname != null && data.scriptname != "") {
                                if(typeof(window[data.scriptname]) === 'function') {
                                    window[data.scriptname](data.param);
                                } else {
                                    console.log('Notice: ' + data.scriptname + '() function not exists on submitForm() ajax success.');
                                }
                            }
                        }
                    }
                }

                // $(".panel-collapse").each(function (i, element) {
                //     $(element).find(".alert").each(function(j,alert){

                //         if ($(alert).hasClass("hide")) {
                //             $(element).collapse("hide");
                //         }
                //         else {
                //             $(element).collapse("show");
                //         }
                //     });
                // });
            }
        }
    });
}

function initMultiUpdateProgressBar()
{
    var progressBar = $('.multiupdate-controls').find('.progress');
    if(!progressBar.length){
        html = '';
        html += '<div class="progress" style="margin-top:15px;">';
        html += '<div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width:0%">';
        html += '<span class="sr-only">0% Complete</span>';
        html += '</div>';
        html += '</div>';

        $('.multiupdate-controls').append(html);
        $('.multiupdate-form').addClass('disabled noClick');
    }

}

function resetMultiUpdateProgressBar()
{
    var progressBar = $('.multiupdate-controls').find('.progress');
    $('.multiupdate-form').removeClass('disabled noClick');
    if(progressBar.length){
        $('.multiupdate-controls .progress').detach();
    }

}

function setMultiUpdateProgressBar(percent)
{
    var progressBar = $('.multiupdate-controls .progress-bar');
    progressBar.css('width', percent+'%').attr('aria-valuenow', percent);
	progressBar.html(percent+"%");
}

// insert new function
function updateinsert(data)
{
    var elementid = datanameFancyBox;
    var insert_id = data.insert_id;
    var element_type = "";

    if(data.element_type != undefined){
        element_type = data.element_type;
    }

    if(datatypeFancyBox == "selectpicker"){
        ajaxupdateSelectpicker(elementid ,dataformnameFancyBox, datacontrollernameFancyBox, insert_id, element_type, fancyboxParamId);
    }

    if(datatypeFancyBox == "duallist"){
        ajaxupdateinsertDualList(elementid,dataformnameFancyBox ,datacontrollernameFancyBox, dataselectedidFancyBox, insert_id, element_type, fancyboxParamId, fancyboxProcess);
    }
}

function ajaxupdateSelectpicker(elementid ,dataformnameFancyBox, datacontrollernameFancyBox, insert_id, element_type, fancyboxParamId)
{
    $.ajax({
        cache: false,
        type: "POST",
        url: root + "ajax/_insertnewelement/updateInsertedElement" ,
        data: {controller: datacontrollernameFancyBox, formname: dataformnameFancyBox, paramid: fancyboxParamId},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            $("#"+elementid+" option").remove();
            $("#"+elementid).selectpicker("refresh");
            $("#"+elementid).append("<option>...</option>");
            $.each(data.result, function() {

                var $option;

                if(element_type === "countries"){
                    $option = $('<option value="'+this.id+'"></option>');
                    $option.attr("data-content", "<img src='"+root+"images/blank.png' class='flag flag-"+this.flagcode+"' alt='"+this.name+"' /> "+this.name);
                } else if (element_type == "chapters"){
                    $option = $('<option value="'+this.id+'"></option>');
                    $option.attr("data-content",this.coursetitle+" - "+this.title);
                    $option.attr("data-style",this.name);

                } else {

                    if(this.type){
                        var concat = this.type+"###"+this.id;
                        $option = $('<option value="'+concat+'"></option>');
                    } else {
                        $option = $('<option value="'+this.id+'"></option>');
                        $option.text(this.name);
                    }

                    if (this.maxheadcount) {
                        $option.attr("data-maxheadcount", this.maxheadcount);
                    }
                    if (this.minheadcount) {
                        $option.attr("data-minheadcount", this.minheadcount);
                    }

                    if(this.style){
                        $option.attr("data-style",this.style);
                    }

                    if (this.name) {
                        $option.attr("data-name", htmlEncode(this.name));
                    }

                    if (this.icon) {
                        $option.attr("data-content", printBootstrapIcontype(this.icon, htmlEncode(this.name)));
                    }
                    if (this.type) {
                        $option.attr("data-type", this.type);
                    }
                    if (this.hourtype) {
                        $option.attr("data-hourtype", this.hourtype);
                    }
                    if (this.theorist_hour) {
                        $option.attr("data-theorist-hours", this.theorist_hour);
                    }
                    if (this.exercise_hour) {
                        $option.attr("data-exercise-hours", this.exercise_hour);
                    }
                    if (this.contact_hour) {
                        $option.attr("data-contact-hours", this.contact_hour);
                    }
                    if (this.category) {
                        $option.attr("data-category", this.category);
                    }
                    if (this.country_id) {
                        $option.attr("data-country", this.country_id);
                    }
                    if (this.city) {
                        $option.attr("data-city", this.city);
                    }
                    if (this.address) {
                        $option.attr("data-address", this.address);
                    }
                    if (this.zip) {
                        $option.attr("data-zip", this.zip);
                    }
                }

                var inserted_type = "";
                if(data.inserted_type != undefined){
                    inserted_type = data.inserte_type;
                }
                 if(insert_id == this.id && inserted_type != "" && inserted_type == this.type){
                 $option.prop('selected', true);
                 }
                 if(insert_id == this.id && inserted_type == ""){
                 $option.prop('selected', true);
                 }

                $("#"+elementid).append($option);

                $("#"+elementid).trigger("change");

            });
            $("#"+elementid).selectpicker('refresh');
            if(elementid == "trainings_and_events"){
                $('#trainings_and_events').trigger("change");
            }

            if(elementid == "checklistgroups"){
                $('#checklistgroups').trigger('change');
            }

            if(elementid == "organisation"){
                $('#organisation').trigger('change');
            }

            remove_title_from_selectpicker();
        }
    });
}

function ajaxupdateinsertDualList(elementid, dataformnameFancyBox, datacontrollernameFancyBox , dataselectedidFancyBox, insert_id, element_type, fancyboxParamId, fancyboxProcess)
{
    var formProcess = typeof process !== 'undefined' ? process : null;
    $.ajax({
        cache: false,
        type: "POST",
        url: root + "ajax/_insertnewelement/updateInsertedElement" ,
        data: {controller: datacontrollernameFancyBox, formname: dataformnameFancyBox, paramid: fancyboxParamId, process: formProcess},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var $element;
            var $text;
            var type;
            var selected;
            var data = $.parseJSON(datas);
            $("#"+elementid).find('li').remove();
            if(datacontrollernameFancyBox == "discounts"){
                $.each(data.result, function () {
                    var suffix = this.symbol ? " "+this.symbol : "%";
                    var classname = this.code ? "disc"+this.code : "discpercent";
                    var active = insert_id == this.id ? " active ":" ";
                    var $li = $('<li class="list-group-item '+active+classname+'" data="' + this.id + '">' + this.t1data +" - "+this.value+suffix+ '</li>');
                    $("#" + elementid).append($li);
                });

                $element = $("#selecteddiscounts");
                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var actives = $(this);
                    if (insert_id == $(this).attr("data"))
                    {
                        var selectedElement = $element.val();
                        if(selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }

                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            } else if(($.inArray(datacontrollernameFancyBox,['users', 'usergroups', 'organisations2']) > -1)){
                type = data.inserted_type;
                $.each(data.result, function () {
                    var name = (this.type == 'USER') ? this.name : this.name +"("+this.count+" "+st.PERSON+ ")";
                    var $li = $('<li class=list-group-item data-id="' + this.id + '" data-type="'+this.type+'" data-name="'+htmlEncode(this.name)+'"></li>');
                    $text = printBootstrapIcontype(this.icon, false)+" <b>#"+this.id+"</b> "+htmlEncode(name);
                    $li.html($text);
                    $("#" + elementid).append($li);
                });
                $("#" + elementid).find("li").each(function () {
                    if (insert_id == $(this).attr("data-id") && type == $(this).attr("data-type")) {
                      $(this).addClass("active");
                    }
                });
                $('#adduser').trigger("click");
            } else if(($.inArray(datacontrollernameFancyBox,['users2', 'usergroups2', 'organisations3']) > -1)){
                var type = data.inserted_type;
                var duallist_left = $("button[data-type=duallist][data-controller="+datacontrollernameFancyBox+"]").closest(".well").find(".duallistblockleft");
                duallist_left.empty();
                // Bal oldali lista felépítése
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'###'+this.type+'"></li>');
                    $text = printBootstrapIcontype(this.icon, false)+" <b>#"+this.id+"</b> "+htmlEncode(this.name);
                    $li.html($text);
                    //$("#" + elementid).append($li);
                    duallist_left.append($li);
                });

                $element = $("#"+dataselectedidFancyBox);
                var selected = $element.val().split(",");
                // Végig eachelünk az összes li-n
                $("#" + elementid).find("li").each(function ()
                {
                    var $id = $(this).attr("data").split("###");
                    var actives = $(this);
                    //console.log("inserted id "+insert_id+" current id "+$id[0]+ "inserted_type "+type+ " c_type"+$id[1]);
                    // Ha a felvett id és típus megegyezik a listában lévő id-val és típussal akkor áttesszük a jobb oldali listába
                    if (insert_id == $id[0] && type == $id[1])
                    {
                        var selectedElement = $element.val();
                        if (selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id+"###"+type);
                        } else {
                            $element.val(insert_id+"###"+type);
                        }
                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                });
                // A selected elementeket kiszedi a bal oldali listából.
                duallist_left.each(function(index, value){
                    var selected = $(value).closest(".form-input-div").find("input[name^=selected]").val().split(",");
                    $.each(selected, function (index, dataid){
                        $(value).find("li[data='"+dataid+"']").remove();
                    });
                });
            }else if(($.inArray(datacontrollernameFancyBox,['users3']) > -1)){
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'" data-category="'+this.trainingareasids+'" data-fullname="'+this.fullname+'"></li>');
                    $text = "<span class='duallistcalendar duallistcalendartrainer' title='Naptár megnyitása'></span> "+htmlEncode(this.name);
                    $li.html($text);
                    $("#" + elementid).append($li);
                });

                //template felépítése
                $("#ulnotselectedtrainers\\#\\#\\#ID\\#\\#\\#").find('li').remove();
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'" data-category="'+this.trainingareasids+'" data-fullname="'+this.fullname+'"></li>');
                    $text = "<span class='duallistcalendar duallistcalendartrainer' title='Naptár megnyitása'></span> "+htmlEncode(this.name);
                    $li.html($text);
                    $("#ulnotselectedtrainers\\#\\#\\#ID\\#\\#\\#").append($li);
                });

                $element = $("#"+dataselectedidFancyBox);
                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var id = $(this).attr("data");
                    var actives = $(this);
                    //console.log("inserted id "+insert_id+" current id "+$id[0]+ "inserted_type "+type+ " c_type"+$id[1]);
                    if (insert_id == id)
                    {
                        var selectedElement = $element.val();
                        if (selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }
                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });

                $('#trainingconstitutionoccasions .move-right').trigger('click');
            }else if(datacontrollernameFancyBox == "usergroups3"){
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'"></li>');
                    $text = htmlEncode(this.name);
                    $li.html($text);
                    $("#" + elementid).append($li);
                });

                $element = (fancyboxProcess == "updategroup") ? $("#selectedusergroupstoadd") : $("#selectedusergroups");

                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var actives = $(this);
                    if (insert_id == $(this).attr("data"))
                    {
                        var selectedElement = $element.val();
                        if (selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }

                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            } else if(datacontrollernameFancyBox == "organisations"){
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'"></li>');
                    $text = htmlEncode(this.name);
                    $li.html($text);
                    $("#" + elementid).append($li);
                });

                $element = (fancyboxProcess == "updategroup") ? $("#selectedorganisationstoadd") : $("#selectedorganisations");

                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var actives = $(this);
                    if (insert_id == $(this).attr("data"))
                    {
                        var selectedElement = $element.val();
                        if (selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }

                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            } else if(datacontrollernameFancyBox == "formfields") {
                $.each(data.result, function () {
                    var required = this.required == "1" ? '<span class="required-star glyphicon glyphicon-asterisk text-danger "></span>' : '';
                    var $li = $('<li class=list-group-item data="' + this.id + '"> &nbsp' + this.question + '&nbsp' + required + '</li>');
                    $("#" + elementid).append($li);
                });

                $element = $("#selected"+datacontrollernameFancyBox+dataindexFancyBox);
                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function () {
                    var actives = $(this);
                    if (insert_id == $(this).attr("data")) {
                        $element = "";
                        if($("#selectedfurtherquestions").length){
                            $element = $("#selectedfurtherquestions");
                        } else {
                            $element = $("#selectedformfields");
                        }
                        var selectedElement = $element.val();
                        if(selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }
                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            } else if(datacontrollernameFancyBox == "means") {
                $.each(data.result, function () {
                    var $li = $('<li class=list-group-item data="' + this.id + '"><span class="duallistcalendar duallistcalendarmean"></span>' + htmlEncode(this.name) + '</li>');
                    $("#" + elementid).append($li);
                });

                //template felépítése
                $("#ulnotselectedmeans\\#\\#\\#ID\\#\\#\\#").find('li').remove();
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'" data-category="'+this.trainingareasids+'" data-fullname="'+this.fullname+'"></li>');
                    $text = "<span class='duallistcalendar duallistcalendartrainer' title='Naptár megnyitása'></span> "+htmlEncode(this.name);
                    $li.html($text);
                    $("#ulnotselectedmeans\\#\\#\\#ID\\#\\#\\#").append($li);
                });

                $element = $("#selected"+datacontrollernameFancyBox+dataindexFancyBox);
                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var actives = $(this);
                    if (insert_id == $(this).attr("data"))
                    {
                        var selectedElement = $element.val();
                        if(selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }

                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            } else if(datacontrollernameFancyBox == "meansproperties"){
                $.each(data.result, function () {
                    var $li = $('<li class="list-group-item" data="'+this.id+'"></li>');
                    $text = htmlEncode(this.name);
                    $li.html($text);
                    $("#" + elementid).append($li);
                });

                $element = $("#selectedproperties");
                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var actives = $(this);
                    if (insert_id == $(this).attr("data"))
                    {
                        var selectedElement = $element.val();
                        if (selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }

                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            } else {
                $.each(data.result, function () {
                    var publics = "";
                    if(typeof this.publics !== 'undefined'){
                        publics = "<img src='" + root + "images/icon" + this.publics + ".png' alt='' style='width: 16px;'/> ";
                    }
                    var $li = $('<li class=list-group-item data="' + this.id + '">' + publics + htmlEncode(this.name) + '</li>');
                    $("#" + elementid).append($li);
                });

                $element = $("#selected"+datacontrollernameFancyBox);
                selected = $element.val().split(",");
                $("#" + elementid).find("li").each(function ()
                {
                    var actives = $(this);

                    if (insert_id == parseInt($(this).attr("data")))
                    {
                        var selectedElement = $element.val();
                        if(selectedElement != "") {
                            $element.val(selectedElement + "," + insert_id);
                        } else {
                            $element.val(insert_id);
                        }

                        actives.removeClass("leftmargin");
                        actives.clone().appendTo('#' + elementid.replace("not", "")).removeClass('active').css('display', '');
                        actives.remove();
                    }
                    else
                    {
                        if($.inArray($(this).attr("data"), selected) != -1)
                        {
                            actives.remove();
                        }
                    }
                });
            }
        }
    });
}

function printBootstrapIcontype($icon,$withname)
{
    $iconstring = "";
    $icontype = $icon.split("-");
    if($icontype[0] == "glyphicon"){
        $iconstring += "<span class='glyphicon "+$icon+"'></span>";
    } else if($icontype[0] == "fa") {
        $iconstring += "<i class='fa "+$icon+"'></i>";
    } else if($icontype[0] == "icon"){
        $iconstring += "<i class='"+$icon+"'></i>";
    }
    if($withname){
        $iconstring += " "+$withname;
    }

    return $iconstring;
}

/*
 * Array exception [Selector, Data attribute, ['Exeption values'], Altert text];
 */
function gotoProcess(process, url, errortext, extraparam, exactlyOneElementRequired, exception) {
    var ep = '';
    var ids = [];

    var $table = $("#datatable");
    var rowId = $table.data('rowid') || 0;

    $table.DataTable().rows('.selected').data().each(function (element, index) {
        if(element[rowId]){
            ids.push(element[rowId]);
        }
    });
    //console.log(ids);

    if (process == "insert" || process == "importxls") {
        var locationHref = root + url;
        if(extraparam && extraparam.length > 0 ) {
            location.href =  locationHref + extraparam;
        } else {
            location.href =  locationHref;
        }
    }

    if (process == "use") {
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            alertDialog(errortext[1]);
        } else if(ids[0] == null){
            alertDialog(errortext[2], null, null, null, "danger");
        } else {
            if(extraparam && extraparam.length > 0 && extraparam[0] == "newtab") {
                window.open(
                    root + url + "/" + ids + extraparam[1],
                    '_blank'
                );
            } else {
                location.href = root + url + "/" + ids;
            }

        }
    }

    if (process == "copy") {
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            alertDialog(errortext[1]);
        } else {
            var locationHref = root + url  + "/" + ids;
            if(extraparam && extraparam.length > 0 ) {
                location.href =  locationHref + extraparam;
            } else {
                location.href =  locationHref;
            }

        }

    }

    if (process == "update") {
        var locationHref;
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else {
            if (ids.length > 1) {
                locationHref = root + url + "group/" + ids;
            } else {
                locationHref = root + url + "/" + ids;
            }

            if(extraparam && extraparam.length > 0 ) {
                location.href =  locationHref + extraparam;
            } else {
                location.href =  locationHref;
            }
        }
    }

    if (process == "updateonly") {
        var locationHref;
        var hasAlert = false;
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            alertDialog(errortext[1]);
        } else {

            if(exception) {
                var dataVal = $('#row_'+ids).find(exception[0]).attr(exception[1]);
                if(exception[2].indexOf(dataVal) >= 0) {
                    hasAlert = true;
                    alertDialog(exception[3]);
                } else {
                    locationHref = root + url + "/" + ids;
                }
            } else {
                locationHref = root + url + "/" + ids;
            }

            if(!hasAlert) {
                if(extraparam && extraparam.length > 0 ) {
                    location.href =  locationHref + extraparam;
                } else {
                    location.href =  locationHref;
                }
            }
        }
    }


    if (process == "view") {
        var locationHref;
        var hasAlert = false;
        if (ids.length == 0) {
            hasAlert = true;
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            locationHref = root + url + "group/" + ids;
        } else {
            locationHref = root + url + "/" + ids;
        }

        if(!hasAlert) {
            if (extraparam && extraparam.length > 0) {
                location.href = locationHref + extraparam;
            } else {
                location.href = locationHref;
            }
        }

    }

    if (process == "viewonly") {
        var locationHref;
        var hasAlert = false;
        if (ids.length == 0) {
            hasAlert = true;
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            hasAlert = true;
            alertDialog(errortext[1]);
        } else {
            locationHref = root + url + "/" + ids;
        }

        if(!hasAlert) {
            if (extraparam && extraparam.length > 0) {
                location.href = locationHref + extraparam;
            } else {
                location.href = locationHref;
            }
        }
    }


    if (process == "delete" ||process == "deleteonly") {
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else {
            if(ids.length > 1 && process == "deleteonly"){
                alertDialog(errortext[2]);
            } else {
                confirmDialog(errortext[1], 'OK', stAdmin.CANCEL, function()
                {
                    $("#datatable_processing").fadeIn("fast");

                    $.ajax({
                        type: "POST",
                        url: root + "ajax/" + url,
                        data: {ids: ids},
                        error: function (x, status, error) {
                            $("#datatable_processing").fadeOut("fast");
                            alertDialog("Status: " + status + " Error: " + error);
                        },
                        success: function responseAjax(datas) {
                            var data = $.parseJSON(datas);
                            if (data.error_db) {
                                alertDialog(data.error_db,null,false,null,"danger");
                            } else {
                                if (data.url == "self") {
                                    //if we delete from user we will show an alert after the delete
                                    if(data.deletedUserArray){
                                        alertDialog(data.deletedUserArray,data.alertTitle,true,function(){(location.reload());},"primary");
                                    } else {
                                        location.reload();
                                        return;
                                    }
                                } else if (data.url != "") {
                                    //if we delete from user we will show an alert after the delete
                                    if(data.deletedUserArray){
                                        alertDialog(data.deletedUserArray,data.alertTitle,true,function(){(location.href = root + data.url);},"primary");
                                    } else {
                                        if(extraparam && extraparam.length > 0 ) {
                                            if (extraparam.indexOf("?parent=") === 0) {
                                                extraparam = "/"+extraparam.substring(8)
                                            }
                                            location.href = root + data.url + extraparam;
                                        } else {
                                            location.href = root + data.url;
                                        }
                                        return;
                                    }
                                }
                            }
                            $("#datatable_processing").fadeOut("fast");
                        }
                    });
                },'','',false,'danger',true);
            }
        }
    }

    if (process == "export" || process == "exportxls") {
        if(exactlyOneElementRequired) {
            if (ids.length == 0) {
                alertDialog(errortext[4]);
                return;
            } else if (ids.length > 1) {
                alertDialog(errortext[5]);
                return;
            }
        }
        /*
        if(
            process == "exportxls" &&
            (
                ($("#datatable").DataTable().rows(".selected").data().length == 0 && $("#datatable").DataTable().page.info().recordsDisplay > 140000) ||
                $("#datatable").DataTable().rows(".selected").data().length > 140000
            )
        ){
            alertDialog(errortext[6]);
            return;
        }*/

        var urlParts = url.split("/");

        if(typeof(extraparam) != "undefined" && $.isArray(extraparam.cvAndAjaxParam) && extraparam.cvAndAjaxParam.length) {
            ep = '?' + extraparam.cvAndAjaxParam.join('&');
        } else if(typeof(extraparam) != "undefined" && extraparam.cvAndAjaxParam != undefined) {
            ep = '?' + extraparam.cvAndAjaxParam;
        } else if(typeof(extraparam) != "undefined" && $.isArray(extraparam.tids) && extraparam.tids.length) {
            // Replace the ids with the tids (type-id list).
            ids = extraparam.tids.join(',');
        } else {
            ep = '';
        }

        var datatableOrder = "";
        if(typeof(extraparam) != "undefined" && extraparam.datatableOrder && extraparam.datatableOrder.length) {
            datatableOrder = extraparam.datatableOrder;
        }

        if (urlParts[1] !== "courses") {
            if (ids.length == 0) {
                if (urlParts[1] === "questionnaires") {
                    alertDialog(errortext[3]);
                    return;
                } else {
                    confirmDialog(errortext[3], errortext[1], errortext[2], function () {
                        if(process == "exportxls") {
                            createXlsExportIframe(urlParts, ids, ep, datatableOrder);
                        } else {
                            location.href = root + url + "/" + ids + ep;
                        }
                    });
                }
            } else if (ids.length > 0) {
                confirmDialog(errortext[0], errortext[1], errortext[2], function () {
                    if(process == "exportxls") {
                        createXlsExportIframe(urlParts, ids, ep, datatableOrder);
                    } else {
                        location.href = root + url + "/" + ids + ep;
                    }
                });
            }
        } else {
            if (ids.length == 0) {
                alertDialog(errortext[4]);
            }
            if (ids.length > 1) {
                alertDialog(errortext[3]);
            }
            if (ids.length == 1) {
                confirmDialog(errortext[0], errortext[1], errortext[2], function () {
                    if(process == "exportxls") {
                        createXlsExportIframe(urlParts, ids, ep, datatableOrder);
                    } else {
                        location.href = root + url + "/" + ids + ep;
                    }
                });
            }
        }
    }

    if (process == "prioritysettings") {
        location.href = root + url;
    }


    if (process == "printing") {

        ep = "";
        if(typeof(extraparam) != 'undefined') {
            ep = extraparam[0];
        }
        var getParams = "?menutop=no&websiteleft=no&footer=no"  + ep;
        window.open(
            root + url + "/" + ids + getParams,
            '_blank'
        );
    }
    if (process == "printingonly") {
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            alertDialog(errortext[1]);
        } else {

            ep = "";
            if(typeof(extraparam) != 'undefined') {
                ep = extraparam[0];
            }
            var getParams = "?menutop=no&websiteleft=no&footer=no" + ep;
            window.open(
                root + url + "/" + ids + getParams,
                '_blank'
            );
        }
    }

    if (process == "xmlexport") {
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else if (ids.length > 50) {
            alertDialog(errortext[1]);
        } else {
            if(typeof startOSAPexport ==="function"){
                startOSAPexport(ids);
            } else {
                alertDialog("Nem definiált funkció!");
            }
        }
    }

    if(process == "generatedocument"){
        var locationHref;
        locationHref = ids.length ?  root + url + "/" + ids : root + url + "/all";

        if(extraparam && extraparam.length > 0 ) {
            location.href =  locationHref + extraparam;
        } else {
            location.href =  locationHref;
        }

    }
}

/************************ Export ******************************** */

/**
 * Sets the export button collection for DataTable
 * @param {array}   buttons             - Completely defined buttons
 * @param {array}   ignoredButtons      - extend value of predefined buttons, that is not needed
 * @param {string}  tableName           - Name of the DataTable
 * @param {string}  customClass         - Custom classes for buttons
 * @param {array}   customOptions       - Custom options for exportOptions
 */
function exportButtons(buttons, ignoredButtons, tableName, customClass, customOptions) {
    customOptions["format"] = {
        body: function ( data, row, column, node ) {

            var $ObjVar = $("<div>"+data+"</div>");

            if($ObjVar.find("img[src$='images/icon0.png']").length){
                return htmlEncode(stAdmin["NO"]);
            }
            if($ObjVar.find("img[src$='images/icon1.png']").length){
                return htmlEncode(stAdmin["YES"]);
            }

            $ObjVar.find(".fa.fa-filter").remove();

            $ObjVar.find('select').each(function(index, element) {
                var $select = $(element);
                $select.replaceWith('<span>'+htmlEncode($select.find('option[selected]').text())+'<span>');
            });

            return $ObjVar.text();

        }
    }

    var defaultButtons = [
        {
            extend: "copy",
            text: "<span class='fa fa-copy'></span>",
            className: customClass,
            titleAttr: stAdmin["DATATABLE_COPY"],
            exportOptions: customOptions,
        },
        {
            extend: "excel",
            text: "<span class='fa fa-download'></span>",
            className: customClass,
            title: "",
            titleAttr: stAdmin["DATATABLE_EXCEL"],
            exportOptions: customOptions,
            filename: function(){return stringToFileName(tableName) + "_" + getCurrentDate();}
        },
        {
            extend: "print",
            text: "<span class='fa fa-print'></span>",
            className: customClass,
            title : tableName,
            titleAttr: stAdmin["DATATABLE_PRINT"],
            exportOptions: customOptions
        },
    ];

    var selectButtons = [{
            extend: "selectAll",
            text: "<span class='fa fa-check-square-o'></span>",
            titleAttr: stAdmin["DATATABLE_SELECT_ALL_ROWS"],
            className: customClass,
        },
        {
            extend: "selectNone",
            text: "<span class='fa fa-ban'></span>",
            titleAttr: stAdmin["DESELECTALL"],
            className: customClass,
        }
    ];

    // Removing chosen predefined buttons
    ignoredButtons.forEach(function(ignoredelement){
        // default buttons
        defaultButtons.forEach(function(element, index) {
            if (element.extend == ignoredelement) {
                defaultButtons.splice(index, 1)
            }
        });
        // select buttons
        selectButtons.forEach(function(element, index) {
            if (element.extend == ignoredelement) {
                selectButtons.splice(index, 1)
            }
        });
    });


    var resultButtons = defaultButtons;


    buttons.forEach(function(element){
        resultButtons.push(element);
    });

    selectButtons.forEach(function(element){
        resultButtons.push(element);
    });




    return resultButtons;
}

/* ********************** Xls Export Start ********************** */

var exportXlsFilenames = [];
var exportXlsIds = [];
var packages = [];
var percentPerPackage;
var packageCounter = 0;
var currentidsLength = 0;
function xlsExportComplete(removeFrame) {
    if(removeFrame) {
        $("#export-iframe").remove();
    }

    $(".export-btn").removeClass("disabled");
    $("#export-in-progress .alert").removeClass("alert-info").addClass("alert-success");
    $("#export-in-progress .alert img").remove();
    $("#export-in-progress .alert").html('<span class="glyphicon glyphicon-ok" aria-hidden="true"></span> '+stt("EXPORT_IS_DONE_SUCCESSFULLY"));

    var files = "";
    $.each(exportXlsFilenames, function(i,v) {
        var title = v.substring(v.lastIndexOf("/")+1);
        var index = i+1;
        files += '<a class="btn btn-primary" href="'+v+'" title="'+title+'" download>'+index+'. <i class="fa fa-file-archive-o" aria-hidden="true"></i><span class="name"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span></span></a>';
    });
    $("#export-in-progress .zips").html(files);
    $("#export-in-progress .files").slideDown();

    $(".datatable_head").removeClass("disabled pointer-events-none");
    $("#datatable_wrapper").removeClass("disabled pointer-events-none");

    /*
    $("#export-in-progress").delay(2000).slideUp(function() {
        $("#export-in-progress").remove();
    });
    */

    exportXlsFilenames = [];
    exportXlsIds = [];
    packages = [];
    packageCounter = 0;
    currentidsLength = 0;

}

function xlsExportInProgressError(status, error) {
    var text = stt(status);
    var alertClass = error ? "alert-danger" : "alert-warning";

    // console.log("status: ",status);
    // console.log("text: ",text);
    $("#export-in-progress .alert").removeClass("alert-info").addClass(alertClass);
    $("#export-in-progress .alert img").remove();
    $("#export-in-progress .alert").text(text);

    if(error === false) {
        /* Only message, not error */
        $("#export-iframe").remove();
        $(".export-btn").removeClass("disabled");

        $(".datatable_head").removeClass("disabled pointer-events-none");
        $("#datatable_wrapper").removeClass("disabled pointer-events-none");

        exportXlsFilenames = [];
        exportXlsIds = [];
        packages = [];
        percentPerPackage = "";
    }
}


function createXlsExportIframe(urlParts, ids, extraparams, datatableOrder) {
    if($("#export-in-progress").length > 0) {
        $("#export-in-progress").slideUp(function() {
            $("#export-in-progress").remove();
            _createXlsExportIframe(urlParts, ids, extraparams, datatableOrder);
        });
    } else {
        _createXlsExportIframe(urlParts, ids, extraparams, datatableOrder);
    }
}

function _createXlsExportIframe(urlParts, ids, extraparams, datatableOrder) {
    xlsExportComplete(true);
    // var exportIframe = '<iframe style="width: 0px; height: 0px; display: none" id="export-iframe" src="'+exportIframeSrc+'" onload="xlsExportComplete(false)"></iframe>';

    var $exportIframe = $('<iframe style="width: 830px; height: 620px; display: none" id="export-iframe" src=""></iframe>');
    var infoRow = '<div id="export-in-progress" style="display: none">';
        infoRow +=  '<div class="alert alert-info processing-info">';
        infoRow +=    '<img src="'+root+'images/loading.gif" alt="loading"> '+stt("EXPORT_IN_PROGRESS");
        infoRow +=    '<div class="progress hide" style="margin-bottom:0;margin-top: 15px;"> <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style=""></div></div>';
        infoRow +=   '</div>';
        infoRow +=   '<div class="files" style="display: none"><h4>'+stt("DOWNLOADABLE_EXCEL_FILE")+':</h4><div class="zips"></div></div>';
        infoRow += '</div>';

    $(".datatable_head").before(infoRow);
    $("#export-in-progress").slideDown();
    $(".export-btn").addClass("disabled");

    $(".datatable_head").addClass("disabled pointer-events-none");
    $("#datatable_wrapper").addClass("disabled pointer-events-none");

    $(".datatable_head").prepend($exportIframe);

    //$exportIframe.get(0).contentWindow.location.replace(exportIframeSrc);
    // console.log("exportIframeSrc:",controller, extraparams);

    var controller = urlParts[1];
    var method = urlParts[2];
    datatableOrder = datatableOrder || '';

    var script = "<script>getIdsXlsExportIframeAjax('"+controller+"', '"+method+"','"+ids+"','"+extraparams+"','"+datatableOrder+"')</script>";
    $('#export-iframe').contents().find('html').html(script);

    $(window).on('message', function (event) {
        console.log(event.originalEvent.data)

        if(typeof event.originalEvent.data !== 'string') return;

        var messageData = event.originalEvent.data.split("###");

        if(messageData[0] == "exportxls") {
            if(messageData[1] == "done") {
                xlsExportComplete(false);
            }
            if(messageData[1] == "error") {
                if(messageData[2] == "errorinprogress") {
                    xlsExportInProgressError("ERRORINPROGRESS", true);
                }
                if(messageData[2] == "timeout") {
                    xlsExportInProgressError("XLSEXPORT_TIMEOUT_ERROR", true);
                }
            }
            if(messageData[1] == "message") {
                xlsExportInProgressError(messageData[2], false);
            }
        }

    });
}


var xlsExportProgreesBarInterval;
var xlsExportProgreesBarIntervalCounter;
function updteXlsExportProgressBar(percent, startInterval, clsearInterval) {

    var $progress = $("#export-in-progress .progress");
    var $progressBar = $progress.find(".progress-bar");

    if($progress.hasClass("hide")) {
        $progress.css("display","none");
        $progress.removeClass("hide");
        $progress.slideDown();
    }

    if(percent) {
        // exact percent
        var correctPercent;
        if(percent == 100) {
            correctPercent = 100;
        } else {
            correctPercent = Math.floor(Math.min(percent,99));
        }
        $progressBar.css("width",correctPercent+"%");
        $progressBar.text(correctPercent+"%");
        $progressBar.attr("data-percent",percent);


        if(startInterval) {
            clearInterval(xlsExportProgreesBarInterval);
            xlsExportProgreesBarIntervalCounter = 1;

            xlsExportProgreesBarInterval = setInterval(function() {
                //console.log("xlsExportProgreesBarInterval");
                //console.log("xlsExportProgreesBarIntervalCounter:",xlsExportProgreesBarIntervalCounter);
                //console.log("currentidsLength:",currentidsLength);
                if(xlsExportProgreesBarIntervalCounter < percentPerPackage-1) {
                    var p = parseFloat($progressBar.attr("data-percent")) + (percentPerPackage/(currentidsLength/102));
                    xlsExportProgreesBarIntervalCounter += (percentPerPackage-1)/(currentidsLength/102);
                    updteXlsExportProgressBar(p, false);
                } else {
                    clearInterval(xlsExportProgreesBarInterval);
                }
            }, 1000);
        }

    } else {
        // next package
        packageCounter++;
        var p = 10+(percentPerPackage*packageCounter);
        updteXlsExportProgressBar(p, true);
    }

    if(clsearInterval) {
        clearInterval(xlsExportProgreesBarInterval);
    }
}

function getIdsXlsExportIframeAjax(controller, method, ids, extraparams, datatableOrder) {
    // console.log("getIdsXlsExportIframeAjax");

    var url = root+'ajax/'+controller+'/get'+method+'ids/'+ids;
    $('#export-iframe').contents().find('html').html(url);
    updteXlsExportProgressBar(5, false, false);

    $.ajax({
        type: "POST",
        url: url,
        data: $.extend(
            getExtraParamsObjFromExtraParamsQuery(extraparams),
            {ids: ids}
        ),
        error: function (x, status, error) {
            console.log("Error", x, status, error);
        },
        success: function responseAjax(datas) {
            try {
                var data = $.parseJSON(datas);
                if (data.success) {
                    // console.log("success, ids: ",data.ids);
                    exportXlsIds.push(data.ids);
                    // console.log("exportXlsIds[0]:",exportXlsIds[0]);

                    packages = exportXlsIds[0].length;
                    percentPerPackage = Math.floor(90/packages);
                    updteXlsExportProgressBar(10, true, false);

                    createXlsExportIframeAjax(controller, method, extraparams, datatableOrder);
                } else {
                    var error = data ? data.error_db || data.error || '' : '';
                    alert(stt('ERRORINPROGRESS', 'Error in progress!') + ' ' + error);
                }
            } catch(err) {
                alert("Timeout:", err);
            }

        }
    });

}

/**
 * Converts a queryString into a name-value object.
 * @param {string} queryParams
 * @return {object}
 */
function getExtraParamsObjFromExtraParamsQuery(queryParams) {
    if(queryParams == null || queryParams == '') return {};
    if(queryParams.substr(0,1) == '?') queryParams = queryParams.substr(1);

    var result = {};

    queryParams.split("&").forEach(function(s){
        var nv = s.split('=');
        if(nv[0] == null) return;
        var key = decodeURIComponentEx(nv[0]);
        var value = nv[1] == null ? null : decodeURIComponentEx(nv[1]);
        result[key] = value;
    });

    return result;
}

/**
 * DecodeURIComponent function, but correctly replaces + signs with spaces while decoding.
 * @param {*} s
 */
function decodeURIComponentEx(s) {
    if(s==null) return s;
    s = s.replace(/\+/g, '%20');
    return decodeURIComponent(s);
}

function createXlsExportIframeAjax(controller, method, extraparams, datatableOrder) {
    // console.log("createXlsExportIframeAjax");

    var url = root+'ajax/'+controller+'/'+method;
    //$('#export-iframe').contents().find('html').html(url);
    var currentids = exportXlsIds[0].shift();
    currentidsLength = currentids.length;
    currentids = currentids.join(",");

    $.ajax({
        type: "POST",
        url: url,
        data: $.extend(
            getExtraParamsObjFromExtraParamsQuery(extraparams),
            {ids: currentids, datatableOrder: datatableOrder}
        ),
        error: function (x, status, error) {
            console.log("Error", x, status, error);
        },
        success: function responseAjax(datas) {

            try {
                var data = JSON.parse(datas);
                // console.log("DATA:",data);

                if (data.success) {
                    exportXlsFilenames.push(data.filename);
                    if(exportXlsIds[0].length > 0) {

                        // console.log("exportXlsIds.length:",exportXlsIds[0].length);
                        // console.log("packages:",packages);
                        //var percent = Math.max( Math.round(((1 - (exportXlsIds[0].length/packages))*100)), 10);
                        updteXlsExportProgressBar(false, true, false);

                        createXlsExportIframeAjax(controller, method, extraparams, datatableOrder);
                    } else {
                        updteXlsExportProgressBar(100, false, true);
                        setTimeout(function() {
                            parent.postMessage("exportxls###done", root);
                        },1000);
                    }
                    //console.log(data.filename);
                    //$('#export-iframe').get(0).contentWindow.location.replace(root+data.filename);
                } else {
                    if (data.error) {
                        console.log("Error in progress!");
                        parent.postMessage("exportxls###error###errorinprogress", root);
                    }
                    if (data.message) {
                        parent.postMessage("exportxls###message###"+data.message, root);
                    }
                }
            } catch(err) {
                console.log("Parse Json Error (Timeout):", err);
                parent.postMessage("exportxls###error###timeout", root);
            }

        }
    });

}

/* ********************** Xls Export END ********************** */


function generateSQLCodeForUpdate(tablename, controllername) {
    if(typeof controllername === 'undefined') controllername = tablename
    var ids = [];
    $("#datatable").DataTable().rows('.selected').data().each(function (element, index) {
        if(element[0]){
            ids.push(element[0]);
        }
    });

    if (ids.length != 0) {
        $.ajax({
            type: "post",
            url: root+"ajax/"+controllername+"/getSQLforUpdate",
            data: {
                    ids: ids,
                    tablename: tablename,
                },
            async: false,
            error: function(x, status, error){
                alertDialog("Status: "+status+" Error: "+error);
            },
            success: function responseAjax(datas){
                var data = $.parseJSON(datas);

                $("#sql-for-update").fadeIn();
                $("#sql-for-update #code").text(data);

                $('html, body').animate({
                    scrollTop: $("#sql-for-update").offset().top
                }, 2000);
            }
        });
    }
}


function gotoProcessTimeRequired(process, url, frm, errortext) {
    var ids = [];
    //var fullscreen = " ?menutop=no&header=no&menubottom=no&websiteleft=no&websiteright=no&footer=no&mobilefriendly=yes";
    var fullscreen = "";
    $("#datatable").DataTable().rows('.selected').data().each(function (element, index) {
        ids.push(element[0]);
    });
    //console.log("from: "+frm+", id: "+ids);
    if (process == "update") {
        if (ids.length == 0) {
            alertDialog(errortext[0]);
        } else if (ids.length > 1) {
            alertDialog(errortext[1]);
        } else {
            location.href = root + url + "/" + frm + "," + ids + fullscreen;
            //console.log(location.href);
        }
    }
    if (process == "delete" || process == "deleteonly") {
        var user_course = [];
        $("#datatable").DataTable().rows('.selected').data().each(function (element, index) {
            user_course.push(element[2]);
            user_course.push(element[4]);
        });

        //console.log(user_course);

        if (user_course.length == 0) {
            alertDialog(errortext[0]);
        } else {
            if (user_course.length > 1 && process == "deleteonly") {
                alertDialog(errortext[2]);
            } else {
                var answer = confirm(errortext[1]);
                if (answer) {
                    $.ajax({
                        type: "POST",
                        url: root + "ajax/" + url,
                        data: {user_course: user_course},
                        error: function (x, status, error) {
                            alertDialog("Status: " + status + " Error: " + error);
                        },
                        success: function responseAjax(datas) {
                            var data = $.parseJSON(datas);
                            if (data.error_db) {

                                alertDialog(data.error_db);

                            } else if (data.url != "") {
                                location.href = root + data.url;
                            }
                        }
                    });
                }
            }
        }
    }
}

/**
 * Starts Excel export.
 * @param {string}  controllerName             - The controller name.
 * @param {boolean} passColumnVisibilityParam  - When true, passes column visibility in cv param.
 * @param {number} [skipColumnCount]           - Skips the first column count.
 * @param {number} [exactlyOneElementRequired] - When TRUE there must be 1 and olny 1 selected element.
 */
function xlsExport(controllerName, passColumnVisibilityParam, skipColumnCount, exactlyOneElementRequired) {
    if(typeof(event) != "undefined" && $(event.target).hasClass("disabled")) return;
    var cv = '';
    var columnsVisibleStr = '';
    if(passColumnVisibilityParam) {
        var columnsVisibleArr = $('#datatable').DataTable().columns().visible();
        columnsVisibleArr = $.map(columnsVisibleArr, function(isVisible){ return isVisible ? 1 : 0; });
        columnsVisibleArr = $.grep(columnsVisibleArr, function(){ return skipColumnCount ? !(skipColumnCount--) : true; });
        columnsVisibleStr = columnsVisibleArr.join('');
        cv = 'cv='+columnsVisibleStr+'&';
    }

    var order = '';
    var $dtOrder = $('#datatable').DataTable().order();
    if($dtOrder.length > 0) {
        $.each($dtOrder, function(i,v) {
            var comma = i == 0 ? "" : ",";
            // substract hidden columns
            var sub = columnsVisibleStr.substring(0,v[0]).split(0).length-1;
            var detailsControl = $('#datatable').find("td.details-control").length > 0 ? 1 : 0;
            order += comma+(v[0]+1-sub-detailsControl)+" "+v[1];
        });
    }

    // console.log("order: ", order);

    gotoProcess(
        'exportxls',
        'admin/' + controllerName + '/exportxls',
        [
            stt('ARE_YOU_SURE_TO_EXPORT_ITEMS'),
            capitalizeFirstLetter(stt('YES')),
            capitalizeFirstLetter(stt('NO')),
            stt('ARE_YOU_SURE_TO_EXPORT_ALL_ITEMS'),
            stt('NOSELECTEDDATA'),
            stt('ONLYONECANSELECTED'),
            stt('UP_TO_LINES_CAN_BE_EXPORTED')
        ],
        {
            "cvAndAjaxParam": cv + getDatatableAjaxParams(),
            "datatableOrder": order

        },
        exactlyOneElementRequired
    );
}

/**
 * Returns the last DataTable AJAX params as GET parameters for data export.
 * @return {string} The last DataTable AJAX params as GET parameters.
 */
function getDatatableAjaxParams(){
    // Get the last AJAX request parameters.
    var table = $('#datatable').DataTable();
    var req = table.ajax.params();

    // Reset request parameters to retrieve all records
    req.start = 0;
    req.length = -1;

    //return 'dtreq=' + encodeURIComponent($.param(req));
    console.log(req);
    return $.param(req);
}

/**
 * Return the translated system text from st object or the system text name if no translation exists.
 * @param {string} name - The system text name
 * @param {string} defaultValue - Optional default value if the system text not exists.
 * @return {string} The translated system text from st object. Returns the defaultValue or the system text name if no translation exists.
 */
function stt(name, defaultValue) {
    if(defaultValue == null) defaultValue = name;
    return typeof(window.st)==='object' && typeof(window.st[name])!=='undefined' ? window.st[name] : defaultValue;
}

/**
 * Displays a JQuery UI dialog, with OK button (https://nakupanda.github.io/bootstrap3-dialog/)
 * @param {string}   text          - The message body
 * @param {string}   [title]       - The message title
 * @param {boolean}  [htmlcontent] - Whether the message body is html (true)
 * @param {callback} [onclosefn]   - Callback function for the dialog close event.
 * @param {string}   type          - Which type of alert is shown [primary, default, success, danger, warning, info]
 * @param {callback} [onshownfn]   - Callback function for the dialog shown event.
 * @param {object}    [options]     - Options: cssClass, closable.
 * @param {string}   size          - Which size of alert is shown [small, wide, large, normal]
 */
function alertDialog(text, title, htmlcontent, onclosefn, type, onshownfn, options, size)
{
    var t;
    var s;

    //Size
    if (typeof size != "undefined")
    {
        switch(size)
        {
            case "small": s = BootstrapDialog.SIZE_SMALL;break;
            case "wide": s = BootstrapDialog.SIZE_WIDE; break;
            case "large": s = BootstrapDialog.SIZE_LARGE; break;
        }
    }
    else
    {
        s = BootstrapDialog.SIZE_NORMAL;
    }

    if (typeof type != "undefined")
    {
        switch(type)
        {
            case "primary": t = BootstrapDialog.TYPE_PRIMARY;break;
            case "default": t = BootstrapDialog.TYPE_DEFAULT; break;
            case "success": t = BootstrapDialog.TYPE_SUCCESS; break;
            case "danger": t = BootstrapDialog.TYPE_DANGER; break;
            case "warning": t = BootstrapDialog.TYPE_WARNING; break;
            case "info": t = BootstrapDialog.TYPE_INFO; break;
        }
    }
    else
    {
        t = BootstrapDialog.TYPE_PRIMARY;
    }
    if (!htmlcontent)
    {
        text = htmlEncode(text, true);
    }

    BootstrapDialog.closeAll();

    BootstrapDialog.show({
        title: title || " ",
        message: text,
        cssClass: (typeof(options) != "undefined" && options.cssClass) ? options.cssClass : "",
        type: t,
        size: s,
        nl2br: false,
        closable: (typeof(options) != "undefined" && options.closable) ? options.closable : false,
        buttons: [{
            label: (typeof(options) != "undefined" && options.labelOk) ? options.labelOk : "Ok",
            cssClass: 'btn-'+type,
            action: function (dialog) {
                dialog.close();
            }
        }],
        onhide: function (dialog) {
            if(typeof(onclosefn)==='function'){
                onclosefn();
            } else if(typeof(window[onclosefn])==='function') {
                window[onclosefn]();
            }
        },
        onshown: function (dialog) {
            if(typeof(onshownfn)==='function'){
                onshownfn();
            } else if(typeof(window[onshownfn])==='function'){
                window[onshownfn]();
            }
        }
    });
}

/**
 * Displays a JQuery UI confirm dialog, with ok/cancel buttons.
 * @param {string}   text              - The dialog body
 * @param {string}   confirmButtonText - The text of the "confirm" button.
 * @param {string}   cancelButtonText  - The text of the "cancel" button .
 * @param {callback} [okclickfn]       - Callback function for the confirm button click event.
 * @param {callback} [cancelclickfn]   - Callback function for the cancel button click event.
 * @param {callback} [onclosefn]       - Callback function for the dialog close event.
 * @param {boolean}  htmlcontent       - Whether the message body is html (true)
 * @param {string}   type              - Which type of alert is shown [primary, default, success, danger, warning, info]
 * @param {boolean}  nl2br             - nl2br true or false
 */
function confirmDialog(text, confirmButtonText, cancelButtonText, okclickfn, cancelclickfn, onclosefn, htmlcontent, type, nl2br){
    var t;
    if (typeof nl2br == "undefined")
    {
        nl2br = false;
    }
    if (typeof type != "undefined")
    {
        switch(type)
        {
            case "primary": t = BootstrapDialog.TYPE_PRIMARY;break;
            case "default": t = BootstrapDialog.TYPE_DEFAULT; break;
            case "success": t = BootstrapDialog.TYPE_SUCCESS; break;
            case "danger": t = BootstrapDialog.TYPE_DANGER; break;
            case "warning": t = BootstrapDialog.TYPE_WARNING; break;
            case "info": t = BootstrapDialog.TYPE_INFO; break;
        }
    }
    else
    {
        t = BootstrapDialog.TYPE_DANGER;
    }
    var title = " ";
    if (!htmlcontent)
    {
        text = htmlEncode(text);
    } else {
        if(typeof htmlcontent == "object") {
            if(htmlcontent.hasOwnProperty("title")) {
                title = htmlcontent.title;
            }
            if(htmlcontent.hasOwnProperty("body")) {
                text = htmlcontent.body;
            }

        } else {
            text = htmlcontent;
        }
    }

    BootstrapDialog.closeAll();

    BootstrapDialog.show({
        title: title,
        message: text,
        type:t,
        closable: false,
        nl2br: nl2br,
        buttons: [{
            label: confirmButtonText,
            cssClass: 'btn-'+type,
            action: function(dialogRef){
                if(typeof okclickfn === "function"){
                    okclickfn();
                    dialogRef.close();
                }else{
                    dialogRef.close();
                }
            }
        },
        {
            label: cancelButtonText,
            cssClass: 'btn-default',
            action: function(dialogRef){
                if(typeof cancelclickfn === "function"){
                    cancelclickfn();
                    dialogRef.close();
                }else{
                    dialogRef.close();
                }
            }
        }],
        onhide: function (dialog) {
            if(typeof(onclosefn)==='function') onclosefn();
        },
    });

}

function selectLanguage() {
    selectLanguageAjax($("#selectlanguage").val());
}

function selectLanguageAjax(languageId) {
    $.ajax({
        type: "POST",
        url: root + "ajax/modul_languageselect/languagechange",
        data: {id: languageId},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            location.reload();
        }
    });
}

function selectWebaim() {

    $.ajax({
        type: "POST",
        url: root + "ajax/modul_webaim/webaimchange",
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            location.reload();
        }
    });
}

function toggleUpdateGroup(id, type, cl) {
    if (type == "selectpicker") {

        $("#" + id).prop("disabled", function (i, v) {
            return !v;
        });
        $("#" + id).selectpicker("refresh");

    } else if (type == "toggle") {

        if ($("#" + id).attr("disabled") == "disabled") {
            $("#" + id).bootstrapToggle("enable");
        } else {
            $("#" + id).bootstrapToggle("disable");
        }

    } else if (type == "duallist") {

        $("#group" + id + " button").prop("disabled", function (i, v) {
            return !v;
        });

    } else if (type == "tinymce") {

        var set = $("#" + id).attr("disabled");
        if (set == "disabled") {
            tinyMCE.get(id).show();
            $("#" + id).removeAttr("disabled");
        } else {
            tinyMCE.get(id).hide();
            $("#" + id).attr("disabled", "disabled");
        }

    } else if (type == "files") {
        var button_id = id.replace("uploadfiles_", "");
        if ($("#updategroup_" + id).prop("checked")) {
            $("#addnewmultiuploadbtn-" + button_id).prop("disabled", false);
            $("#uploadfiles_"+button_id).fileinput('enable');
        } else {
            $("#addnewmultiuploadbtn-" + button_id).prop("disabled", true);
            $("#uploadfiles_"+button_id).fileinput('disable');
        }
    } else if (type == "dynamicdocument"){
        if ($("#updategroup_" + id).prop("checked")) {
            $("#"+id+"_container").removeClass('disabled noClick');
        } else {
            $("#"+id+"_container").addClass('disabled noClick');
        }
    } else if (type == "again") {

        $("#" + id).prop("disabled", function (i, v) {
            return !v;
        });
        $("#" + id + "_again").prop("disabled", function (i, v) {
            return !v;
        });

    } else if (type == "other") {

        $("#" + id).prop("disabled", function (i, v) {
            return !v;
        });
    }else if(type == "checkbox"){

        if ($("#updategroup_" + id).prop("checked")) {
            $("." + cl).prop("disabled", false);
        } else {
            $("." + cl).prop("disabled", true);
        }

    } else if(type == "tabletag"){
        $('.'+cl).toggleClass('disabled noClick')
    } else {

        if ($("#updategroup_" + id).prop("checked")) {
            $("#" + id).prop("disabled", false);
        } else {
            $("#" + id).prop("disabled", true);
        }

    }
}

function toggleUpdategroupOther(id, type, idsArray, typesArray) {
    $("#updategroup_" + id).prop("checked");

    toggleUpdateGroup(id, type);

    for (var i = 0; i < idsArray.length; i++) {
        toggleUpdateGroup(idsArray[i], typesArray[i]);
    }
}

function toggleCollapse(id0, id1, type1, id2, type2) {
    if ($("#" + id0).prop("checked")) {

        if (type1 == "selectpicker") {
            $("#" + id1).selectpicker("hide");
        } else {
            $("#" + id1).addClass("hidden");
        }

        if (type2 == 'selectpicker') {
            $("#" + id2).selectpicker("show");
        } else {
            $("#" + id2).removeClass("hidden");
        }

    } else {

        if (type2 == "selectpicker") {
            $("#" + id2).selectpicker("hide");
        } else {
            $("#" + id2).addClass("hidden");
        }

        if (type1 == "selectpicker") {
            $("#" + id1).selectpicker("show");
        } else {
            $("#" + id1).removeClass("hidden");
        }

    }
}

function toggleShowHide(id, value, checked) {
    if (checked) {

        if (($("#" + id).prop("checked")) && ($("#toggle_" + id).css("display") == "none")) {
            $("#toggle_" + id).slideToggle("slow");
        } else if (!($("#" + id).prop("checked")) && ($("#toggle_" + id).css("display") != "none")) {
            $("#toggle_" + id).slideToggle("slow");
        }

    } else {

        if (($("#" + id).val() == value) && ($("#toggle_" + id).css("display") == "none")) {
            $("#toggle_" + id).slideToggle("slow");
        } else if (($("#" + id).val() != value) && ($("#toggle_" + id).css("display") != "none")) {
            $("#toggle_" + id).slideToggle("slow");
        }

    }
}

function getMediaID3(filename, input, runfunction) {
    $.ajax({
        type: "POST",
        url: root + "ajax/slideelementinsert/getMediaID3",
        data: {filename: filename},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            //console.log(data["width"]+" "+data["height"]);
            $("#" + input).attr("mediawidth", data.width);
            $("#" + input).attr("mediaheight", data.height);

            var attr = $("#" + input).attr("data-width");
            if (typeof attr !== typeof undefined && attr !== false) {
                $("#" + input).attr("data-width", data.width);
                $("#" + input).attr("data-height", data.height);
            }

            if (runfunction) {
                setPattern();
            }
        }
    });
}

function scaleSize(maxW, maxH, currW, currH) {
    var ratio = currH / currW;

    if (currW >= maxW && ratio <= 1) {
        currW = maxW;
        currH = currW * ratio;
    } else if (currH >= maxH) {
        currH = maxH;
        currW = currH / ratio;
    }

    return [currW, currH];
}

function openPopupFilemanager(url) {
    var w = 880;
    var h = 570;
    var l = Math.floor((screen.width - w) / 2);
    var t = Math.floor((screen.height - h) / 2);
    filemanagerWindow = window.open(root + url, 'filemanagerWindow', "scrollbars=1,width=" + w + ",height=" + h + ",top=" + t + ",left=" + l);
}

function rgb2hex(rgba) {

    rgba = rgba.substring(rgba.indexOf('(') + 1, rgba.length - 1);
    var nums = rgba.split(",");

    var r = parseInt(nums[0].trim());
    var g = parseInt(nums[1].trim());
    var b = parseInt(nums[2].trim());
    var a = (nums[3]) ? parseFloat(nums[3].trim()) : "";

    var hex = (a) ? (a).toString(16).slice(2, 4) : "";
    var full = "#" + hex + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

    return full;

}

function pixelToPoint(px) {
    return Math.round(px * 72 / 96);
}

function setAnimationpattern() {
    var val = $("#slideranimation option:selected").attr("data-anim");

    if (val != "noanim") {

        var currentslidefrom = {left: '0px'};
        var currentslideto;
        var actslidefrom;
        var actslideto = {left: '0px'};

        $("#animationpattern").css(currentslidefrom);

        if (val == "Left") {
            currentslideto = {left: '-60px'};
            actslidefrom = {left: '-60px'};
        } else if (val == "Right") {
            currentslideto = {left: '60px'};
            actslidefrom = {left: '60px'};
        } else if (val == "LeftRight") {
            currentslideto = {left: '60px'};
            actslidefrom = {left: '-62px'};
        } else if (val == "RightLeft") {
            currentslideto = {left: '-62px'};
            actslidefrom = {left: '60px'};
        }

        //console.log(currentslideto+" "+actslidefrom);

        $("#animationpattern").velocity(currentslideto, {
            duration: 500,
            easing: "swing",
            queue: "",
            begin: undefined,
            progress: undefined,
            complete: function () {
                $("#animationpattern").css(actslidefrom);

                $("#animationpattern").velocity(actslideto, {
                    duration: 500,
                    easing: "swing",
                    queue: "",
                    begin: undefined,
                    progress: undefined,
                    complete: undefined,
                    display: undefined,
                    visibility: undefined,
                    loop: false,
                    delay: false,
                    mobileHA: true
                });
            },
            display: undefined,
            visibility: undefined,
            loop: false,
            delay: false,
            mobileHA: true
        });

    }

}

function loadTableOfContent() {
    $.ajax({
        type: "POST",
        url: root + "ajax/lessons/loadTableOfContent",
        data: {id: $("#id").val(), cid: $("#chapter").val()},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);

            (data.empty == true) ? $(".buttons").addClass("hide") : $(".buttons").removeClass("hide");

            $(".contents-course").html(data.title);
            $(".list").html(data.contents);

        }
    });
}


function loadSliderstyle() {
    $("#sliderstyletag").remove();

    //if($("#sliderstyle").val() != ""){

    $.ajax({
        type: "POST",
        url: root + "ajax/lessons/loadSliderstyle",
        data: {id: $("#sliderstyle").val(), cid: $("#chapter").val()},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            $("head").append("<style id='sliderstyletag'>" + data.css + "</style>");

            if (data.pdf != "") {
                $("#framestyle").css("display", "");
                $("#framestyle a").attr("href", root + data.pdf);
            } else {
                $("#framestyle").css("display", "none");
                $("#framestyle a").attr("href", "");
            }
        }
    });

    //}

}

function loadSliderstylePattern() {

    $("#sliderstylepatterntag").remove();

    if ($("#sliderstyle").val() != "") {

        $.ajax({
            type: "POST",
            url: root + "ajax/sliderstyles/loadSliderstyle",
            data: {
                fcolor: $("#fontcolor").val(),
                fsize: $("#fontsize").val(),
                ffamily: $("#fontfamily option:selected").attr("data-content"),
                sliderbackground: $("#slidesbackground").val()
            },
            error: function (x, status, error) {
                alertDialog("Status: " + status + " Error: " + error);
            },
            success: function responseAjax(datas) {
                $("head").append("<style id='sliderstylepatterntag'>" + datas + "</style>");
            }
        });

    }

}

function generateTaskByForm() {

    if ($("#tasktype").val() != "") {
        tinyMCE.triggerSave();
        $.ajax({
            type: "POST",
            url: root + "ajax/tasks/generateTask",
            data: $("#tasksform").serialize(),
            error: function (x, status, error) {
                alertDialog("Status: " + status + " Error: " + error);
            },
            success: function responseAjax(datas) {
                var data = $.parseJSON(datas);
                $("#taskpattern").html(data.data);
                $.fancybox.open({
                    'href': '#taskpattern',
                    'transitionIn': 'fade',
                    'transitionOut': 'fade',
                    'titleShow': false,
                    'width': 800,
                    'height': 600
                });
            }
        });

    }

}

function generateTaskByid(taskid, exam) {
    $.ajax({
        type: "POST",
        url: root + "ajax/tasks/generateTask",
        data: {taskid: taskid, exam: exam},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            //console.log(data["data"]);
            $("#actualtask").val(data.data);
            setPattern();
        }
    });
}


function replayTaskByForm(randomtaskid) {
    $.ajax({
        type: "POST",
        url: root + "ajax/tasks/generateTask",
        data: parent.$("#tasksform").serialize(),
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            $("#" + randomtaskid).remove();
            $("#taskpattern").html(data.data);
        }
    });
}

function replayTaskById(taskid, randomtaskid, exam) {
    if (isMobile) {
        console.log("IsMobile = " + isMobile + ", resetting task from save HTML.");
        var $parent3 = $("#" + randomtaskid).parent().parent().parent();
        $parent3.html($parent3.data('html'));
        return;
    }

    var contentid = $("#" + randomtaskid).parent().parent().parent().attr("id");

    var examval = "false";

    if (typeof exam !== typeof undefined && exam !== false) {
        if (exam == 1) {
            examval = "true";
        }
    }

    $.ajax({
        type: "POST",
        url: root + "ajax/tasks/generateTask",
        data: {taskid: taskid, exam: examval},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            var append = $("#" + contentid + " .sliderelementcontenta .maincontent");
            if ($("#" + randomtaskid).parent().hasClass("hiddencontent")) {
                append = $("#" + randomtaskid).parent();
            }
            $("#" + randomtaskid).remove();
            append.html(data.data);

            $(append).find(".taskcontainer div").each(function () {
                var ad;
                if (!$("#slideelementanimation").prop("checked")) {
                    $(this).removeClass("animated");
                    ad = $(this).css("animation-delay");
                    $(this).attr("data-animation-delay", ad);
                    $(this).css("animation-delay", "");
                } else {
                    if (!$(this).hasClass("animated")) {
                        $(this).addClass("animated");
                        ad = $(this).attr("data-animation-delay");
                        $(this).css("animation-delay", ad);
                    }
                }
            });
        }
    });
}

function replaceTask(exam) {
    $(".realtask").each(function (index, element) {
        var $element = $(this);
        var id = $(this).find(".taskid").val();
        //var type = $(this).attr("data-tasktype");

        $.ajax({
            type: "POST",
            url: root + "ajax/tasks/generateTask",
            data: {taskid: id, exam: exam},
            error: function (x, status, error) {
                alertDialog("Status: " + status + " Error: " + error);
            },
            success: function responseAjax(datas) {
                var data = $.parseJSON(datas);

                $task = $(data.data);
                if (!$("#slideelementanimation").prop("checked")) {

                    var ad = $task.find(".animated").css("animation-delay");
                    $task.find(".animated").attr("data-animation-delay", ad);

                    $task.find(".animated").removeClass("animated").addClass("noanim").css("animation-delay", "");
                }
                $element.replaceWith($task);
            }
        });
    });
}

function saveTasks() {
    $(".realtask").each(function (index, element) {
        var $parent3 = $(element).parent().parent().parent();
        $parent3.data('html', $parent3.html());
    });
}

function checkTask1(id) {
    var sol = $("#" + id + " .sol").val();
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var bad = 0;
    var good = 0;

    //var solution = $("#"+id+" input[name=task1_solution"+id+"]:checked").val();

    $("#" + id + " input[name=task1_solution" + id + "]").each(function (index, value) {
        $(this).removeClass("taskbadanswer");
        $(this).removeClass("taskgoodanswer");

        if ($(this).is(':checked')) {
            if (sol == $(this).val()) {
                $(this).addClass("taskgoodanswer");
                good++;
            } else {
                $(this).addClass("taskbadanswer");
                bad++;
            }
        }
        /* else {
         if(sol != $(this).val()) {
         $(this).addClass("taskgoodanswer");
         good++;
         } else {
         $(this).addClass("taskbadanswer");
         bad++;
         }
         }*/
        taskcount++;
    });

    if ($("#" + id + "_taskreplaysubmit").hasClass("btn")) {
        $("#" + id + "_taskchecksubmit").addClass("hide");
        $("#" + id + "_taskreplaysubmit").removeClass("hide");
    }

    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);

    if (scoretype == '1') {
        if (good == 1) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        $("#" + id + " .sumanswer").val((score) + " / " + (score * good));
    }

    if ((good == 0) && (bad == 0)) {
        bad = 1;
    }

    checkTaskAnswer(bad, id);
}

function checkTask2(id) {
    var sol = $("#" + id + " .sol").val();
    var sols = sol.split("###");
    var solsnumber = sols.length;
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var bad = 0;
    var good = 0;

    //var solution = $("#"+id+" input[name=task1_solution"+id+"]:checked").val();

    $("#" + id + " input[name=task2_solution" + id + "]").each(function (index, value) {
        $(this).removeClass("taskbadanswer");
        $(this).removeClass("taskgoodanswer");

        if ($(this).is(':checked')) {
            if (sols.indexOf($(this).val()) >= 0) {
                $(this).addClass("taskgoodanswer");
                good++;
            } else {
                $(this).addClass("taskbadanswer");
                bad++;
            }
        }
        /*else {
         if(sols.indexOf($(this).val()) < 0) {
         $(this).addClass("taskgoodanswer");
         good++;
         } else {
         $(this).addClass("taskbadanswer");
         bad++;
         }
         }*/
        taskcount++;
    });

    if ($("#" + id + "_taskreplaysubmit").hasClass("btn")) {
        $("#" + id + "_taskchecksubmit").addClass("hide");
        $("#" + id + "_taskreplaysubmit").removeClass("hide");
    }

    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);

    if (scoretype == '1') {
        if ((bad == 0) && (good == solsnumber)) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        if (bad == 0) {
            $("#" + id + " .sumanswer").val((score * solsnumber) + " / " + (score * good));
        } else {
            $("#" + id + " .sumanswer").val((score * solsnumber) + " / 0");
        }
    }

    checkTaskAnswer(bad, id);
}

function checkTask3(id) {
    var sol = $("#" + id + " .sol").val();
    var sols = sol.split("###");
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var good = 0;
    var bad = 0;

    for (var i = 1; i <= sols.length - 1; i++) {
        var tval = "t" + i + "-" + $("#" + id + " #" + id + "_t" + i).val();

        if (tval == sols[i - 1]) {
            $("#" + id + " #" + id + "_t" + i).removeClass("taskbadanswer");
            $("#" + id + " #" + id + "_t" + i).removeClass("taskgoodanswer");
            $("#" + id + " #" + id + "_t" + i).addClass("taskgoodanswer");
            good++;
        } else {
            $("#" + id + " #" + id + "_t" + i).removeClass("taskbadanswer");
            $("#" + id + " #" + id + "_t" + i).removeClass("taskgoodanswer");
            $("#" + id + " #" + id + "_t" + i).addClass("taskbadanswer");
            bad++;
        }
        taskcount++;
    }

    if ($("#" + id + "_taskreplaysubmit").hasClass("btn")) {
        $("#" + id + "_taskchecksubmit").addClass("hide");
        $("#" + id + "_taskreplaysubmit").removeClass("hide");
    }

    //console.log(good+" - "+bad+" - "+taskcount+" - "+score+" - "+scoretype);
    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);
    if (scoretype == '1') {
        if (bad == 0) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        $("#" + id + " .sumanswer").val((score * taskcount) + " / " + (score * good));
    }

    checkTaskAnswer(bad, id);
}

function checkTask4(id) {
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var good = 0;
    var bad = 0;

    $("div[id^=" + id + "_s]").each(function (index, element) {
        var s = $(this).attr("id").replace(id + "_s", "");
        var dt = $(this).attr("data-target");
        //var t = 0;

        /*if(typeof dt !== typeof undefined && dt !== false) {
         t = dt.replace("t","");
         }*/

        if ($(this).attr("data-s") == $("#" + id + "_" + dt).attr("data-s")) {
            $("#" + id + "_h" + s).removeClass("taskbadanswer");
            $("#" + id + "_h" + s).removeClass("taskgoodanswer");
            $("#" + id + "_h" + s).addClass("taskgoodanswer");
            good++;
        } else {
            $("#" + id + "_h" + s).removeClass("taskbadanswer");
            $("#" + id + "_h" + s).removeClass("taskgoodanswer");
            $("#" + id + "_h" + s).addClass("taskbadanswer");
            bad++;
        }
        taskcount++;
    });

    $("#" + id + "_taskchecksubmit").addClass("hide");
    $("#" + id + "_taskreplaysubmit").removeClass("hide");


    //console.log(good+" - "+bad+" - "+taskcount+" - "+score+" - "+scoretype);
    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);
    if (scoretype == '1') {
        if (bad == 0) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        $("#" + id + " .sumanswer").val((score * taskcount) + " / " + (score * good));
    }

    checkTaskAnswer(bad, id);
}

function checkTask5(id) {
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var good = 0;
    var bad = 0;

    var i = 1;
    $("#" + id + " .tasksortable .sort").each(function (index, element) {
        if ($(this).attr("data-s") == i) {
            $(this).find(".taskcircle").removeClass("taskbadanswer");
            $(this).find(".taskcircle").removeClass("taskgoodanswer");
            $(this).find(".taskcircle").addClass("taskgoodanswer");
            good++;
        } else {
            $(this).find(".taskcircle").removeClass("taskbadanswer");
            $(this).find(".taskcircle").removeClass("taskgoodanswer");
            $(this).find(".taskcircle").addClass("taskbadanswer");
            bad++;
        }
        taskcount++;
        i++;
    });

    if ($("#" + id + "_taskreplaysubmit").hasClass("btn")) {
        $("#" + id + "_taskchecksubmit").addClass("hide");
        $("#" + id + "_taskreplaysubmit").removeClass("hide");
    }

    //console.log(good+" - "+bad+" - "+taskcount+" - "+score+" - "+scoretype);
    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);
    if (scoretype == '1') {
        if (bad == 0) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        $("#" + id + " .sumanswer").val((score * taskcount) + " / " + (score * good));
    }

    checkTaskAnswer(bad, id);
}

function checkTask6(id) {
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var good = 0;
    var bad = 0;

    $("div[id^=" + id + "_s]").each(function (index, element) {
        var s = $(this).attr("id").replace(id + "_s", "");
        var dt = $(this).attr("data-target");
        var t = 0;

        if (typeof dt !== typeof undefined && dt !== false) {
            t = dt.replace("t", "");
        }

        if (s == t) {
            $("#" + id + "_h" + s).removeClass("taskbadanswer");
            $("#" + id + "_h" + s).removeClass("taskgoodanswer");
            $("#" + id + "_h" + s).addClass("taskgoodanswer");
            good++;
        } else {
            $("#" + id + "_h" + s).removeClass("taskbadanswer");
            $("#" + id + "_h" + s).removeClass("taskgoodanswer");
            $("#" + id + "_h" + s).addClass("taskbadanswer");
            bad++;
        }
        taskcount++;
    });

    $("#" + id + "_taskchecksubmit").addClass("hide");
    $("#" + id + "_taskreplaysubmit").removeClass("hide");


    //console.log(good+" - "+bad+" - "+taskcount+" - "+score+" - "+scoretype);
    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);
    if (scoretype == '1') {
        if (bad == 0) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        $("#" + id + " .sumanswer").val((score * taskcount) + " / " + (score * good));
    }

    checkTaskAnswer(bad, id);
}

function checkTask7(id) {
    var score = parseFloat($("#" + id + " .score").val());
    var scoretype = $("#" + id + " .scoretype").val();

    var taskcount = 0;
    var good = 0;
    var bad = 0;

    $("div[id^=" + id + "_s]").each(function (index, element) {
        var s = $(this).attr("id").replace(id + "_s", "");
        var dt = $(this).attr("data-target");
        var t = 0;

        if (typeof dt !== typeof undefined && dt !== false) {
            t = dt.replace("t", "");
        }

        if (s == t) {
            $("#" + id + "_h" + s).removeClass("taskbadanswer");
            $("#" + id + "_h" + s).removeClass("taskgoodanswer");
            $("#" + id + "_h" + s).addClass("taskgoodanswer");
            good++;
        } else {
            $("#" + id + "_h" + s).removeClass("taskbadanswer");
            $("#" + id + "_h" + s).removeClass("taskgoodanswer");
            $("#" + id + "_h" + s).addClass("taskbadanswer");
            bad++;
        }
        taskcount++;
    });

    $("#" + id + "_taskchecksubmit").addClass("hide");
    $("#" + id + "_taskreplaysubmit").removeClass("hide");


    //console.log(good+" - "+bad+" - "+taskcount+" - "+score+" - "+scoretype);
    $("#" + id + " .goodanswer").val(good);
    $("#" + id + " .badanswer").val(bad);
    if (scoretype == '1') {
        if (bad == 0) {
            $("#" + id + " .sumanswer").val(score + " / " + score);
        } else {
            $("#" + id + " .sumanswer").val(score + " / 0");
        }
    } else {
        $("#" + id + " .sumanswer").val((score * taskcount) + " / " + (score * good));
    }

    checkTaskAnswer(bad, id);
}

function checkTaskAnswer(bad, id) {
    var source = "";

    if (bad == 0) {

        var goodcontent = $("#answerbygood" + id + " .answerbyinside")[0].innerHTML;

        if (goodcontent.length != 0) {
            $("#answerbygood" + id).css("display", "block");

            $("#answerbygood" + id).find("img").show().each(function () {
                //this.offsetHeight;
                source = $(this).attr("src");
            }).prop('src', source);

            $("#answerbygood" + id).click(function () {
                $(this).css("display", "none");
            });
        }
    } else {

        var badcontent = $("#answerbybad" + id + " .answerbyinside")[0].innerHTML;

        if (badcontent.length != 0) {
            $("#answerbybad" + id).css("display", "block");

            $("#answerbybad" + id).find("img").show().each(function () {
                //this.offsetHeight;
                source = $(this).attr("src");
            }).prop('src', source);

            $("#answerbybad" + id).click(function () {
                $(this).css("display", "none");
            });
        }
    }
}

function checkExamSol(randomtaskid) {
    var usersol = "";
    var values;

    switch ($("#" + randomtaskid).attr("data-tasktype")) {
        case "1":
            usersol = $("input:radio[name='task1_solution" + randomtaskid + "']:checked").val();
            break;
        case "2":
            values = $("input:checkbox[name='task2_solution" + randomtaskid + "']:checked").map(function () {
                return this.value;
            }).get();
            usersol = values.join(",");
            break;
        case "3":
            values = [];
            for (var i = 1; i <= $("#" + randomtaskid + " .task3answerselect").length; i++) {
                values.push("t" + i + "-" + $("#" + randomtaskid + " #" + randomtaskid + "_t" + i).val());
            }
            usersol = values.join(",");
            break;
        case "4":
            break;
        case "5":
            break;
        case "6":
            break;
        case "7":
            break;
        default:
            break;
    }

    return usersol;
}

function creatreQuestionMediaPopup(media, id) {
    var type = media.slice(-3);
    var tag = "";
    switch (type) {
        case "jpg":
        case "png":
            tag = '<img style="max-width: 535px;max-height: 435px;" src=' + root + media + ' >';
            break;
        case "mp4":
        case "avi":
            tag = '<video src="' + root + media + '" style="max-width: 535px;max-height: 435px;" preload="none" controls=""></video>';
            break;
        case "mp3":
            tag = '<audio src="' + root + media + '" width="535px" height="30px" preload="none" controls=""></audio>';
            break;
        case "swf":
            tag = '<object type="application/x-shockwave-flash" data="' + root + media + '" width="535" height="435"  style="max-width: 535px;max-height: 435px;"></object>';
            break;
        default:
            break;
    }
    $("#myModal" + id + " .modal-body").html(tag);

}

function setTaskDraggable(id) {

    $("#" + id + " .taskdraggable").draggable({
        containment: $(this).parent(),
        zIndex: 100,
        cursor: "move",
        cursorAt: {left: 25, top: 25},
        helper: "clone",
        revert: true,
        start: function (event, ui) {
            ui.helper.removeClass("animated");
        }
    });

    $("#" + id + " .taskdroppable").droppable({
        drop: function (event, ui) {
            var t = $(event.target);
            var s = $(ui.draggable);
            var h = s.clone();
            var top = parseInt(t.position().top);
            var left = parseInt(t.position().left);

            if (t.hasClass("free")) {

                var attr = s.attr("data-target");
                if (typeof attr !== typeof undefined && attr !== false) {
                    $("#" + attr).addClass("free");
                }

                s.draggable("option", "revert", false);
                s.draggable("disable");
                s.css({"cursor": "auto", "opacity": "0.35"});
                s.attr("data-target", t.attr("id").replace(id + "_", ""));
                s.removeClass("animated");

                var nr = s.attr("id").replace(id + "_s", "");
                $("#" + id + "_a" + nr).removeClass("animated");
                $("#" + id + "_a" + nr).css("opacity", "0.35");

                h.attr("id", id + "_h" + nr);
                h.removeClass("animated");
                h.appendTo("#" + id + " .taskcontentleft");
                h.css({
                    "cursor": "auto",
                    "opacity": "1",
                    "position": "absolute",
                    "top": top + "px",
                    "left": left + "px"
                });

                t.removeClass("free");

            }

        }
    });
}

function setTaskSortable(id) {
    $("#" + id + " .tasksortable").sortable({
        axis: "y",
        start: function (event, ui) {
            ui.item.removeClass("animated");
        }
    });
}

function closePopup() {
    var fancy = document.getElementsByClassName("fancybox-overlay");

    if (fancy.length > 0) {
        $.fancybox.close();
    } else if (getFullscreenElement()) {
        exitFullscreenFn();
    } else {
        mobileCommand('BACK');
    }

}

var resizeTimerID = -1;
var setMobileZoomInitDone = false;
var fullscreenOn = false;
var offlinePlayerVersion;
function setMobileZoom(playerVersion) {
    if (!setMobileZoomInitDone) {
        setMobileZoomInitDone = true;

        if (typeof(playerVersion) !== 'undefined') offlinePlayerVersion = playerVersion;

        //called when an event goes full screen and vice-versa.
        $(document).on("fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange", onFullscreenStateChange);

    }

    // Don't resize the page when any element is in fullscreen mode
    if (getFullscreenElement()) {
        return;
    } else if (fullscreenOn) {
        checkFullscreen();
    }

    // Adjust CSS transform where native css transform is unavailable in the browser
    adjustCssTransform();

    // Adjust zoom
    var $container = $('.container-fluid.websitelessons');
    var $containerOuter = $container.parent().css({'width': 'auto'});
    var w = $containerOuter[0].scrollWidth;
    // var h=$containerOuter.outerHeight(true); //  outerHeight with margins
    var h = $containerOuter[0].scrollHeight;
    $container.css({display: 'none'});
    var cw = document.documentElement.clientWidth;
    var ch = document.documentElement.clientHeight;
    $container.css({display: ''});
    var scaleW = cw / w;
    var scaleH = ch / h;
    var scale = Math.min(scaleW, scaleH);
    var paddingWidth = Math.max(0, cw - w * scale) / 2;
    var paddingHeight = Math.max(0, ch - h * scale) / 2;

    $containerOuter
        .width(w).height(h)
        .css({
            position: "absolute",
            left: paddingWidth + 'px',
            top: paddingHeight + 'px',
            'max-width': 'auto',
            margin: 0,
            padding: 0,
            overflow: 'visible',
            'transform-origin': 'top left',
            transform: 'scale(' + scale + ',' + scale + ')'
        })
        .data({scale: scale});

    if (resizeTimerID < 0) {
        resizeTimerID = 0;
        $(window).resize(updateMobileZoom);
        updateMobileZoom();
    }
}

function onFullscreenStateChange() {
    var element = getFullscreenElement();
    //log('Screen change. Full screen='+(!!element));
    if (element) {
        fullscreenOn = true;
        mobileCommand('FULLSCREEN-STATE', !!element ? 1 : 0);
    } else {
        // Leaving full screen mode
        // We request a manual full screen mode exit for compatibility
        checkFullscreen();
    }
}

function updateMobileZoom() {
    clearTimeout(resizeTimerID);
    resizeTimerID = setTimeout(setMobileZoom, 50);
}

function requestFullscreenFn(element) {
    //requestFullscreen is used to display an element in full screen mode.
    if ("requestFullscreen" in element) {
        element.requestFullscreen();
    } else if ("webkitRequestFullscreen" in element) {
        element.webkitRequestFullscreen();
    } else if ("mozRequestFullScreen" in element) {
        element.mozRequestFullScreen();
    } else if ("msRequestFullscreen" in element) {
        element.msRequestFullscreen();
    }
}

function getFullscreenElement() {
    //fullscreenElement is assigned to html element if any element is in full screen mode.
    return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
}

function checkFullscreen() {
    var fsElement = getFullscreenElement();

    if (!fsElement) {
        exitFullscreenFn();
    }

    mobileCommand('FULLSCREEN-STATE', !!fsElement ? 1 : 0);
}

function exitFullscreenFn() {
    fullscreenOn = false;
    if ("exitFullscreen" in document) {
        document.exitFullscreen();
    } else if ("webkitExitFullscreen" in document) {
        document.webkitExitFullscreen();
    } else if ("mozCancelFullScreen" in document) {
        document.mozCancelFullScreen();
    } else if ("msExitFullscreen" in document) {
        document.msExitFullscreen();
    }
}

/**
 * Sends log message to the offline player framework
 * @param message The message
 */
function log(message) {
    if (typeof(offlinePlayerVersion) !== 'undefined') {
        mobileCommand('LOG', message);
    } else if (typeof(console) === 'object') {
        console.log(message);
    }
}

/**
 * Sends command to the offline player framework
 * @param {string} command The mobile command to send
 * @param {...*} params    Optional parameters
 */
function mobileCommand(command, params) {
    for (var i = 1; i < arguments.length; i++) command += '|' + encodeURIComponent(arguments[i]);
    if (isMobile) window.location = 'http://learningage.hu/#appCommand=' + command;
}

/**
 * Adjusts CSS transform where native css transform is unavailable in the browser
 */
function adjustCssTransform() {
    $('#cleft .num,#actslide,#allslide').each(function (index, element) {
        var $element = $(element);
        if (!$element.data('transform')) {
            if ($element.css('transform') == 'none') {
                $element.css('transform', 'none')
                    .parent().css({'padding': 0, 'margin': 0});
                var eTop = parseFloat($(element).css('top'));
                var eHeight = $element.height();
                var eNewTop = eTop - eHeight / 2;
                $element.css({'top': eNewTop + 'px'});
            }
            $element.data('transform', true);
        }
    });
}

function setAnim(id, anim) {
    $("#" + id).removeAttr("class");
    $("#" + id).addClass("animationpattern");
    $("#" + id).addClass("animated " + $("#" + anim).val());
    $("#" + id).css("animation-delay", "0.5s");
}

function setOtherData(selectid, datas, fieldsid) {
    var fieldid = fieldsid.split(",");
    var data = datas.split(",");

    var i = 0;
    $.each(data, function (index, value) {
        var actvalue = $('#' + selectid + ' option:selected').data(value);
        $("#" + fieldid[i]).val(actvalue).selectpicker('refresh');
        i++;
    });
}

/**
 * Genral Ajax call
 *
 * Displays "confirm" message, then executes an Ajax call at "url".
 * If "url" is not available displays the "notavailable" message, then navigates to "notavailableurl".
 * Checks the returned data object's error_db property for error.
 * If the call succeeds, displays the optional "success" message or the optional "message" property returned by the Ajax call.
 * If the call fails, displays the optionial "error" message or the optional, "error_db" property returned by the Ajax call.
 * Finally navigates to "successurl" or "errorurl" or the "url" property returned by the Ajax call.
 *
 * @param string url                URL for the Ajax call
 *
 * Params object (optional):
 * @param string notavailable        "Service not available" message
 * @param string notavailableurl    Navigation target if service is not available
 * @param string confirm            Confirmation message
 * @param string success            Success message
 * @param string successurl            Navigation target if Ajax call is successful
 * @param string error                Error message
 * @param string errorurl            Navigation target if Ajax call returns errors
 */
function callAjax(url, params) {
    if (!params.confirm || confirm(params.confirm)) {
        $.ajax({
            url: root + "ajax/" + url,
            success: function (response) {
                var data = $.parseJSON(response);
                var error = !data || data.errors;
                if (error) {
                    data = data || {};
                    if (params.error) alertDialog(params.error);
                    else if (data.error_db) alertDialog(data.error_db);
                    if (params.errorurl) nav(root + params.errorurl);
                    else if (data.url) nav(root + data.url);
                } else {
                    if (params.success) alertDialog(params.success);
                    else if (data.message) alertDialog(data.message);
                    console.log(params.successurl);
                    if (params.successurl) nav(params.successurl);
                    else if (data.url) nav(root + data.url);
                }
            },
            error: function () {
                if (params.notavailable) alertDialog(params.notavailable);
                if (params.notavailableurl) nav(root + params.notavailableurl);
            }
        });
    }

    function nav(url) {

        if (location.href == url) {
            location.reload(true);
        } else {
            location.href = url;
            location.reload(true);
        }
    }
}

function animate(element, elementClass) {
    $(element).removeClass(elementClass + ' animated').addClass(elementClass + ' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        $(this).removeClass(elementClass + ' animated');
    });
}

/**
 * HTML encodes a string.
 * @param {string} text               The text to econde.
 * @param {bool}   preserveLineBreaks (optional) When TRUE, '\n' or '\r\n' line breaks are preserved (replaced with <br> tags).
 * @returns {string} The HTML encoded string.
 */
function htmlEncode(text, preserveLineBreaks) {
    var result = $('<div/>').text(text).html();
    if(preserveLineBreaks) result = result.replace(/\r\n|\n/g, '<br>');
    return result;
}

/**
 * Returns the plain text version of a HTML string.
 * @param {string} html The HTML string.
 * @returns {string} The plain text string.
 */
function htmlToText(html) {
    return $("<div/>").html(html).text();
}

/**
 * This function replaces previously given special chars in HTML, like " or '
 *
 * @param {string} text
 */
function htmlSpecialCharsEscape(text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}

function regexpEscape(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

/* Math object extensions */

(function() {

    /**
     * Clamps a number between a minimum and maximum value.
     * @memberof Math
     * @param {number} x - The number to clamp.
     * @param {number} min - The minimum value.
     * @param {number} max - The maximum value.
     * @return {number} The clamped value.
     */
    function clamp(x, min, max) {
        return isNaN(x) ? NaN : Math.min(max, Math.max(min, x));
    }

    Math.clamp = Math.clamp || clamp;

})();


/* Advanced Search */

function showDetails(skipStartAdvancedsearch) {
    $("#showdetails").addClass("hide");
    $("#hidedetails").removeClass("hide");
    $("#advancedSearchContainer").slideDown();

    $("#advancedSearchContent  .advancedSearchTable .advancedSearchSelect select").selectpicker();
    if(typeof skipStartAdvancedsearch != "undefined" && skipStartAdvancedsearch == "skipStartAdvancedsearch") {
        // skip start_advancedsearch();
    } else {
        start_advancedsearch();
    }


}

function hideDetails() {
    $("#showdetails").removeClass("hide");
    $("#hidedetails").addClass("hide");
    $("#advancedSearchContainer").slideUp();
    removeAdvancedSearch(false);
}

function deleteFromCart(circle, id, sure) {

    var answer = confirm(sure);
    if (answer) {

        circle.start();

        $.ajax({
            type: "POST",
            url: root + "ajax/modul_shopping1/deleteProductFromCart",
            data: {id: id},
            error: function (x, status, error) {
                circle.stop();
                alertDialog("Status: " + status + " Error: " + error);
            },
            success: function responseAjax(datas) {
                circle.stop();
                var data = $.parseJSON(datas);

                if (data.error_db != "") {
                    alertDialog(data.error_db);
                } else {
                    location.href = root + data.url;
                }

            }
        });
    }
}

function checkShoppingStatus(event, id) {

    if(event && event.preventDefault) {
        event.preventDefault();
        event.stopPropagation();
    }

    $.ajax({
        type: 'POST',
        url: root + 'ajax/shoppings/checkShoppingStatus',
        data: {id: id},
        error: function(x, status, error){
            if(status === 'abort') return;
            alert('Status: ' + status + ' Error: ' + error);
        },
        success: function responseAjax(datas){
            var data = $.parseJSON(datas);
            console.log(data);
            if(!data || !data.success || !data.answer || !data.answer.responseBody || data.errors && data.errors.length) {
                if(data.errors && data.errors.length) {
                    alertDialog(
                        'Hibakódok: \n'+data.errors.join('\n'),
                        'SimplePay válasz',
                        false
                    );
                } else if(data.answer && (!data.answer.transactions || data.answer.transactions.length)) {
                    alert(st.SHOPPINGS_ERROR_PAYMENT_NOT_RECORDED);
                } else {
                    alert(st.ERRORINPROGRESS);
                }
                return;
            }

            a = data.answer.transactions.length == 1 ? data.answer.transactions[0] : data.answer.transactions;

            alertDialog(
                JSON.stringify(a, null, "\xA0\xA0\xA0\xA0"),
                'SimplePay válasz',
                false
            );

        }
    });
}

function payingShopping(conftext, cleartext, id) {

    var answer = confirm(conftext);
    if (answer) {

        if ($("#datetimepickerpaydate" + id + " input").val() == "") {
            alertDialog(cleartext);
        } else {

            var $btn = $("#btn_shopping_" + id);
            var circle = null;
            if($btn.length) {
                $btn.addClass('ladda-button');
                circle = Ladda.create($btn.get(0));
                circle.start();
            }

            $.ajax({
                type: "POST",
                url: root + "ajax/shoppings/payingShopping",
                data: {id: id, pdate: $("#datetimepickerpaydate" + id + " input").val()},
                error: function (x, status, error) {
                    alertDialog("Status: " + status + " Error: " + error);
                    if(circle) circle.stop();
                },
                success: function responseAjax(datas) {
                    var data = $.parseJSON(datas);

                    if (data.error_db != "") {

                        alertDialog(data.error_db);
                        if(circle) circle.stop();

                    } else {

                        location.reload();

                    }

                }
            });

        }
    }
}

function formatNumber(num, separator) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + separator);
}

/**
 * Replaces numbered placeholders in a string, with a list of values.
 * Eg.: formatString('The {0} {1} jumps over the {0} {2}','quick','fox','rabbit') = 'The quick fox jumps over the quick rabbit'
 * @param {string} str The string with numbered placeholders.
 * @param {...*} args Any number of parameters, referenced in the "str" parameter, starting with {0}.
 * @return The resulted string with placeholders replaced.
 */
function formatString(str, args) {
    for (var i = 0; i < arguments.length - 1; i++) {
        var regexp = new RegExp('\\{' + i + '\\}', 'gm');
        str = str.replace(regexp, arguments[i + 1]);
    }
    return str;
}

function facebookShareCheck(id, url) {

    $.ajax({
        type: "POST",
        url: root + "ajax/" + url + "/facebookShareCheck",
        data: {id: id},
        error: function (x, status, error) {
            alertDialog("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            if (data.errors) {
                alertDialog(data.error_db);
            } else {
                location.reload();
            }
        }
    });
}

function setShoppingSessionData() {
    $.ajax({
        type: "POST",
        url: root + "ajax/modul_shopping4/setSessionData",
        data: $("#shopping4form").serialize(),
        async: false,
        error: function (x, status, error) {
            if (x.readyState == 0 || x.status == 0) {
                return;
            } else {
                alertDialog("Status: " + status + " Error: " + error);
            }
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            if (data.errors) {
                alertDialog(data.error_db);
            }
        }
    });

}

function initRating(id, confirmtext, ratingcomment) {

    if (id.toString().indexOf("-") != -1) {
        var idsplit = id.toString().split("-");
        var cid = idsplit[0];
    } else {
        var cid = id;
    }

    $("#rateit" + id).rateit();

    $("#rateit" + id).bind('rated', function () {
        $("#id").val(id);
        $("#rating").val($(this).rateit('value'));
        $("#ratingcomment").val(ratingcomment);

        // save rating star number
        $.ajax({
            type: "POST",
            url: root+"ajax/_courseratings/insertRatings",
            data: {id: cid, rating: $(this).rateit('value')},
            error: function(x, status, error){
                alertDialog("Status: "+status+" Error: "+error);
            },
            success: function responseAjax(datas){
                var data = $.parseJSON(datas);

                if (data.error_db != "") {

                    alertDialog(data.error_db);

                }
            }
        });

        // open comment fancybox
        $.fancybox({
            href: '#courserating',
            modal: true,
            scrolling: 'no'
        });
    });

    $("#rateit" + id).bind('beforereset', function (event) {
        if (!confirm(confirmtext)) {
            event.preventDefault();
        }
    });

    $("#rateit" + id).bind('reset', function () {

        $.ajax({
            type: "POST",
            url: root + "ajax/_courseratings/deleteRatings",
            data: {id: cid, rating: $(this).attr('data-rateit-value')},
            error: function (x, status, error) {
                alertDialog("Status: " + status + " Error: " + error);
            },
            success: function responseAjax(datas) {
                var data = $.parseJSON(datas);

                if (data.error_db != "") {

                    alertDialog(data.error_db);

                } else {

                    if (data.url == "self") {
                        location.reload();
                    } else if (data.url != "") {
                        location.href = root + data.url;
                    }

                }

            }
        });
    });
}

/**
 * Dynamically Load a CSS file.
 * The CSS file will be inserted if it is not a duplicate:
 *   - before the first <link rel="stylesheet" href="{beforeCssFile}">
 *   - or after the first <link rel="stylesheet" href="{afterCssFile}">
 *   - or after the last <link rel="stylesheet"> element
 *   - or at the end of the <head> section
 * @param {string|string[]} cssFilename   - The path and filename of the CSS file(s) to load
 * @param {string}          beforeCssFile - Optional: The new CSS file will be loaded before this CSS file
 * @param {string}          afterCssFile  - Optional: The new CSS file will be loaded after this CSS file
 */
function loadCss(cssFilename, beforeCssFile, afterCssFile) {
    var cssFilenames = $.isArray(cssFilename) ? cssFilename : [cssFilename];
    var beforeElement = null;
    var afterElement = (afterCssFile == null) ? $('head > link:last-of-type') : null;
    var i;
    $('link[rel=stylesheet]')
    .each(function(index,link){
        var href = ($(link).attr('href') || '').split('?')[0];
        for(i = cssFilenames.length - 1; i >= 0; i--) {
            if(startsWith(href, cssFilenames[i])) {
                cssFilenames.splice(i);
                if(!cssFilenames.length) return false;
            }
        }
        if(!afterElement && startsWith(href, afterCssFile)) {
            afterElement = link;
        } else if(!beforeElement && startsWith(href, beforeCssFile)) {
            beforeElement = link;
        }
    });
    if(!cssFilenames.length) return;
    var createLinkElement = function(filename) { return $('<link rel="stylesheet"/>').attr('href', cssFilenames[i]); };
    if(beforeElement) {
        for(i = 0; i < cssFilenames.length; i++) {
            createLinkElement().insertBefore(beforeElement);
        }
    } else if(afterElement) {
        for(i = cssFilenames.length - 1; i >= 0; i--) {
            createLinkElement().insertAfter(afterElement);
        }
    } else {
        for(i = 0; i < cssFilenames.length; i++) {
            $(document.head).append(createLinkElement());
        }
    }
}

/**
 * Determine if a string starts with a given substring.
 *
 * @param {string}          haystack - Name of string.
 * @param {string|string[]} needle   - Substring(s) to search for.
 *
 * @return {bool} True if found, false otherwise
 */
function startsWith(haystack, needle) {
    if(haystack == undefined || needle == undefined) return false;
    if(!$.isArray(needle)) needle = [needle];

    for (var index in needle) {
        if (needle.hasOwnProperty(index)) {
            var s = needle[index];
            if(haystack.substr(0,s.length) == s) return true;
        }
    }

    return false;
}

/**
 * Determine if a string ends with a given substring.
 *
 * @param {string}          haystack - Name of string.
 * @param {string|string[]} needle   - Substring(s) to search for.
 *
 * @return {bool} True if found, false otherwise
 */
function endsWith(haystack, needle) {
    if(haystack == undefined || needle == undefined) return false;
    if(!$.isArray(needle)) needle = [needle];

    for (var index in needle) {
        if (needle.hasOwnProperty(index)) {
            var s = needle[index];
            if(!s.length || haystack.substr(-s.length) == s) return true;
        }
    }

    return false;
}

/**
 * @param {Array} params The ids or type
 */
function courseGroupsShowHide(params) {

    if ($(".websitecourses").length == 0) return;

    // MyCourses detecting
    var WebLoc = window.location.href.split("\/");
    var WebHash = (window.location.hash == "")? "#" : window.location.hash;
    WebLoc = WebLoc[WebLoc.length - 1];
    WebLoc = WebLoc.replace(WebHash,"");

    // Átvesszük a coursebanners-ből a tananyagaim url-jét, így nem kell minden egyes alkalommal AJAX-ot futtatni
    var MyCoursesURL = getMyCoursesURL();

    if(WebLoc == MyCoursesURL){
        var hash = "own";
        var items = ["own"];
        $(".websitecourses-top .form_title").html(st.MYCOURSES);
    } else {

        if (params != undefined) {
            if (params.length == 1 && params[0] == 'all') {
                var hash = "all";
                var items = params;
            } else {
                var hash = params.join();
                var items = params;
            }

        } else {
            var hash = window.location.hash.substring(1);
            var items = hash.split(",");
        }

        if (window.location.hash != hash)  window.location.hash = hash;

    }

    if (hash.length === 0) {
        $(".coursegroups-panel").removeClass("hash-hidden");
        $(".coursestate-permview").removeClass("hash-hidden");
    } else {
        $("#mycoursesalert").html("");

        if (items.length != 1 || $.isNumeric(items[0])) {
            $(".coursegroups-panel").not("#sortby-container").addClass("hash-hidden");
        } else {
            $(".coursegroups-panel").not("#sortby-container").removeClass("hash-hidden");
        }

        if (!$.inArray('free', items) > -1 && !$.inArray('pay', items) > -1) {
            $(".coursegroups .item:not(.coursegroup-title-item)").removeClass("hash-hidden");
        }

        $.each(items, function (k, v) {
            if ($.isNumeric(v)) {
                //console.log(v,"Szám");
                $(".coursegroups-panel .item").addClass("hash-hidden");
                $("#Course" + v).removeClass("hash-hidden");
                $("#Course" + v + " .item").each(function() {
                    $(this).removeClass("hash-hidden");
                    var classList = "";
                    var classListArray = $(this).attr('class').split(/\s+/);
                    $.each(classListArray, function(ck,cv){
                        classList += "."+cv;
                    });
                    $("#sortby-container "+classList).first().removeClass("hash-hidden");
                });
            } else {
                //console.log(v,"Szöveg");
                $(".coursegroups-panel .item:not(.coursegroup-title-item)").addClass("hash-hidden");
                if (v == "pay") {
                    $(".item .panel.coursestate-purchasable").closest(".item").removeClass("hash-hidden");

                    $(".coursegroups-panel").not("#sortby-container").each(function (index) {
                        if ($(this).find(".item:not(.coursegroup-title-item)").not("[style*='display: none']").not(".hash-hidden").length == 0) {
                            $(this).addClass("hash-hidden");
                        }
                    });
                } else if (v == "free" || v == "own") {
                    $(".item .panel").not(".coursestate-purchasable").closest(".item").removeClass("hash-hidden");
                    $(".coursegroups-panel").not("#sortby-container").each(function (index) {
                        if ($(this).find(".item:not(.coursegroup-title-item)").not("[style*='display: none']").not(".hash-hidden").length == 0) {
                            $(this).addClass("hash-hidden");
                        }
                    });
                } else if (v == "all") {
                    $(".item:not(.coursegroup-title-item)").removeClass("hash-hidden");
                }

            }

            if($(".websitecourses > div:not(.websitecourses-top) .panel-group[id^='Course']").not("[style*='display: none']").not(".hash-hidden").length == 0){
                switch (v) {
                    case "own":
                    case "free":
                        $("#mycoursesalert").html(st.MYCOURESES_NO_AVAILABLE_COURSE);
                        break;

                    case "pay":
                        $("#mycoursesalert").html(st.MYCOURESES_NO_PURCHASABLE_COURSE);
                        break;

                    default:
                        $("#mycoursesalert").html(st.MYCOURESES_NO_COURSEGROUPS_BY_ID);
                        break;
                }
            }
        });
    }
}


function convertSecToTimeFormat(sec_num) {
    sec_num =  Math.round(sec_num);
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours+':'+minutes+':'+seconds;
}

(function (namespace) { // Closure to protect local variable "var hash"
	if ('replaceState' in history) { // Yay, supported!
		namespace.replaceHash = function (newhash) {
			if (('' + newhash).charAt(0) !== '#') newhash = '#' + newhash;
			history.replaceState('', '', location.pathname + newhash);
		};
	} else {
		var hash = location.hash;
		namespace.replaceHash = function (newhash) {
			if (location.hash !== hash) history.back();
			location.hash = newhash;
		};
	}
})(window);


function getUrlParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
			results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function parseURL(url) {
    var parser = document.createElement('a'),
        searchObject = {},
        queries, split, i;
    // Let the browser do the work
    parser.href = url;
    // Convert query string to object
    queries = parser.search.replace(/^\?/, '').split('&');
    for( i = 0; i < queries.length; i++ ) {
        split = queries[i].split('=');
        searchObject[split[0]] = split[1];
    }
    return {
        protocol: parser.protocol,
        host: parser.host,
        hostname: parser.hostname,
        port: parser.port,
        pathname: parser.pathname,
        search: parser.search,
        searchObject: searchObject,
        hash: parser.hash
    };
}

/*****************************
 *  Advanced search by click *
 *****************************/

function advancedsearch(item, column, condition)
{

    showDetails("skipStartAdvancedsearch");
    var params = {
        item: item,
        column: column,
        condition: condition
    };
	clear_advancedsearch(advancedsearchAfterClear,params);

}

function advancedsearchAfterClear(params, rowCount) {

    var item = params.item;
    var column = params.column;
    var condition = params.condition;

    var $search = $('#advancedSearchContent .advancedSearchTable #advancedsearch_tr_'+rowCount);

    $search.find("[name=fields]").selectpicker("refresh");
    $search.find("[name=fields]").val(column).change().selectpicker("refresh");


    $search.find("[name=condition]").selectpicker("refresh");
    $search.find("[name=condition]").val(condition).selectpicker("refresh");

    if(!$search.find("[name=searchtext]").closest(".advancedSearchInput").hasClass("hide")) {
        $search.find("[name=searchtext]").val(item);
    }
    if(!$search.find("[name=searchtextyesno]").closest(".advancedSearchYesNo").hasClass("hide")) {
        $search.find("[name=searchtextyesno]").val(item).selectpicker("refresh");
    }
    if(!$search.find("[name=searchtextmoreoptions]").closest(".advancedMoreoptions").hasClass("hide")) {
        $search.find("[name=searchtextmoreoptions]").val(item).selectpicker("refresh");
    }

    start_advancedsearch();
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};

/**********************
 *  Addthis share log *
 *********************/

function eventHandler(evt) {
    //console.log(evt.data);
    switch (evt.type) {
        case "addthis.menu.open":
            //console.log('menu opened; surface=' + evt.data.pane);
            break;
        case "addthis.menu.close":
            //console.log('menu closed; surface=' + evt.data.pane);
            break;
        case "addthis.menu.share":
            //console.log(evt.data);
            sendAddthisShareToUserActivities(evt.data.service, evt.data.url);
            break;
        default:
            //console.log('received an unexpected event', evt);
    }

}

function sendAddthisShareToUserActivities(services, url)
{
    //console.log(services);
    $.ajax({
       type: "POST",
       data: {
                services: services,
                url: url
             },
       url: root+"ajax/sync/sendAddthisShareToUserActivities",
       error: function(x, status, error){
        alert("Status: "+status+" Error: "+error);
       },
       success: function responseAjax(datas){
          //console.log('success');
       }
  });
}


/**
 * Prepend download button every file type in footer area if file title is appeared
 *
 * @param directory name of directory
 */
function initFileinputFooter()
{
    var fileinputfooter = $(".file-thumbnail-footer");
    var downloadTemplate = "";
    downloadTemplate = "<a href='"+root+"{data-directory}/{data-filename}' class='file-footer-download btn btn-xs btn-default' title='"+st.DOWNLOAD+"' ><i class='glyphicon glyphicon-download-alt'></i></a>";


    if($(fileinputfooter).length) {
        $.each($(fileinputfooter), function(index, element){
            var getFileVersion = $(element).closest(".getfile-version").length > 0 ? true : false;

            if(getFileVersion) {

                if($(element).find(".file-footer-buttons .file-footer-download").length > 0) return; // allready set

                // Caption is a name and filename is a getfile download url
                var srcTitle = $(element).closest(".file-preview-frame").find(".kv-file-content img").attr("title");

                var title = $(element).find(".file-footer-caption").attr("title");
                $(element).closest(".file-preview-frame").find(".kv-file-content img").attr("title",title);
                $(element).closest(".file-preview-frame").find(".kv-file-content img").attr("alt",title);

                $(element).closest(".file-preview-frame").find(".file-drag-handle").addClass("hide");

                var customDownloadTemplate = "<a href='"+srcTitle+"' class='file-footer-download btn btn-xs btn-default' title='"+st.DOWNLOAD+"' ><i class='glyphicon glyphicon-download-alt'></i></a>";
                $(element).find(".file-footer-buttons").prepend(customDownloadTemplate);

            } else {

                $directory = "";
                if($(element).closest(".file-preview-frame").attr("title")){
                    $directory = $(element).closest(".file-preview-frame").attr("title");
                } else {
                    $directory = $(element).closest(".file-preview-frame").find(".kv-file-content img").attr("src");
                }
                if($directory.length) {
                    $directory = $directory.replace(root, "").split("/");
                    $directory.pop();
                    $directory = $directory.join("/");
                    var temp_downloadTemplate = downloadTemplate.replace(/\{data-directory}/g, $directory);
                    $file_footer_buttons = $(element).find(".file-footer-buttons");
                    if ($file_footer_buttons.length) {
                        $file_footer_caption = $(element).find(".file-footer-caption");

                        var filename = '';
                        filename = $file_footer_caption.attr("title");
                        if (!$file_footer_buttons.find(".file-footer-download").length && filename && $directory) {
                            temp_downloadTemplate = temp_downloadTemplate.replace(/\{data-filename}/g, filename);
                            $file_footer_buttons.prepend(temp_downloadTemplate);
                        }
                    }
                }
            }

        });
    }
}

/**
 *
 * This global function remove element from array by value
 *
 * @returns {Array} return array without the removed element
 *
 */
Array.prototype.removeByValue = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

/**
 *
 * This global function is return the difference between two array. The order is important, the first array is not to be empty
 *
 * Usage => [1, 2, 3, 4, 5, 6].diff([2, 4, 6]);
 *
 * @returns {Array} return array without the removed element
 *
 */
Array.prototype.diff = function (a) {
    if(Array.isArray(a)){
        return this.filter(function (i) {
            return a.indexOf(i) === -1;
        });
    }
};

/**
 * Convert all chars in the string (accent, whitespace etc.) to english chars.
 *
 * @param {string} str The data, what you want to convert.
 *
 * @return string self.
 */
function stringToFileName(str) {
    str = str.toLowerCase();
    if(!stringToFileName.translate_re) stringToFileName.translate_re = /[áéíóúüűöőÁÉÍÓÜÚŰÖŐ ]/g;
    var translate = {
        "á": "a", "ö": "o", "ő": "o",
        "é": "e", "í": "i", "ű": "u",
        "ü": "u", "ó": "o", "ú": "u",
        "Á": "A", "Ö": "O", "Ő": "O",
        "É": "E", "Í": "I", "Ű": "U",
        "Ú": "U",
        "Ü": "U", "Ó": "O", " ": "_"
        // probably more to come
    };
    return ( str.replace(stringToFileName.translate_re, function(match) {
        return translate[match];
    }) );
}

/**
 * This function check new form transform duallist required checkbox is checked or not, set value by state
 *
 * @param {object} actual clicked checkbox
 */
function checkAndSetCheckboxState(actual)
{
    $(actual).is(":checked") ? $(actual).val(1) : $(actual).val(0);
    if($(actual).data("requiredfield")){

        if($(actual).is(":checked")){
            $(actual).attr("title", st.REQUIRED_FILL_IN);
            $(actual).siblings(".required-star").removeClass("hide");
        } else {
            $(actual).attr("title", st.NOT_REQUIRED_FILL_IN);
            $(actual).siblings(".required-star").addClass("hide");
        }

    }
}

function switchInputRequired(inputs,required,controller, needsToBeCheckedSessionName, callBack)
{
    $.ajax({
        type: "POST",
        data: {
            inputs: inputs,
            required: required,
            needsToBeCheckedSessionName: needsToBeCheckedSessionName
        },
        url: root + "ajax/" + controller +"/switchInputRequired",
        error: function (x, status, error) {
            alert("Status: " + status + " Error: " + error);
        },
        success: function responseAjax(datas) {
            var data = $.parseJSON(datas);
            if(data.success){
                callBack();
            } else {
               console.error('switchInputRequired error: ', data.errors);
            }
        }
    });
}

/**
 * You can switch inputs required property
 * @param {array} inputs
 * @param {blooean} required
 * @param {string} controller
 * @param {string} callBack
 * @param {string} needsToBeCheckedSessionName
 */
function required(inputs, required, controller, callBack, needsToBeCheckedSessionName)
{
    if(typeof needsToBeCheckedSessionName == "undefined") needsToBeCheckedSessionName = null;
    if(typeof callBack == "undefined") callBack = null;
    switchInputRequired(inputs, required, controller, needsToBeCheckedSessionName, function()
    {
        $.each(inputs, function(i, input)
        {
            var asterisk = $("#"+input+"-information-div").children(".required").children(".glyphicon-asterisk");
            var requiredEl = $("#"+input+"-information-div").children(".required");
            if(!required)
            {
                $("#"+input+"-label").removeClass("form-label-required");
                $("#"+input+"-label").addClass("form-label-nonrequired");
                asterisk.addClass("hide");
            }
            else
            {
                $("#"+input+"-label").removeClass("form-label-nonrequired");
                $("#"+input+"-label").addClass("form-label-required");
                if(asterisk.length){
                    asterisk.removeClass("hide");
                } else {
                    asterisk.removeClass("hide");
                    requiredEl.append('<span class="glyphicon glyphicon-asterisk" title="'+stAdmin["REQUIREDFIELD"]+'"></span>');
                }
            }
        });

        if(typeof callBack === "function")
        {
            callBack();
        }
    });
}

/**
 * This function is convert a string to url safe string
 * @param {string} url
 */
function convertStringToURLSafe(url) {
    var t = url.split('');
    var string = "";
    for (i = 0; i < t.length; i++) {
        t[i] = t[i].toLowerCase();
        t[i] = t[i].replace(/[őóö]/ig, "o");
        t[i] = t[i].replace(/[úűü]/ig, "u");
        t[i] = t[i].replace(/á/ig, "a");
        t[i] = t[i].replace(/é/ig, "e");
        t[i] = t[i].replace(/í/ig, "i");
        t[i] = t[i].replace(" ", "_");
        t[i] = t[i].replace(".", "_");
        t[i] = t[i].replace(",", "_");
        t[i] = t[i].replace(";", "_");
        t[i] = t[i].replace(":", "_");
        t[i] = t[i].replace("!", "_");
        t[i] = t[i].replace("'", "_");
        t[i] = t[i].replace("\"", "_");
        t[i] = t[i].replace("\"", "_");
        t[i] = t[i].replace("?", "_");
        t[i] = t[i].replace("&", "_");
        t[i] = t[i].replace("%", "_");
        t[i] = t[i].replace("+", "_");
        t[i] = t[i].replace("/", "_");
        t[i] = t[i].replace("(", "_");
        t[i] = t[i].replace(")", "_");

    }

    var string = t.join("");
    return string;
}

/**
 * Refreshes the result of a row in the datatable.
 * @param {number} rowId 		- The ID of the row in the database.
 * @param {string} controller	- The name of controller
 */
function refreshDatatableRow(rowId,controller) {
    $row = $('#row_'+rowId);
    if(!$row.length) return;

    $.ajax({
        type: 'POST',
        url: root + 'ajax/'+controller+'/selectData',
        data: {refresh_row_id: rowId},
        error: function(x, status, error){
            alert('Status: ' + status + ' Error: ' + error);
        },
        success: function responseAjax(datas){
            var data = $.parseJSON(datas);
            if(data && !data.errors) {

                if(data.data && data.data[0]) {
                    $('#datatable').DataTable().row('#row_'+rowId).data(data.data[0]);
                    $row.addClass('background-transition qnrz-table-row-highlight')
                        .one('webkitTransitionEnd mozTransitionEnd MSTransitionEnd oTransitionEnd transitionend', function(event){
                            $(event.target).removeClass('qnrz-table-row-highlight background-transition');
                        });
                    //refreshStatusHighlight(rowId)
                }
            } else {
                console.log('ERROR', data);
            }
        }
    });
}

/**
 * Capitalizes the first character of a string.
 * @param {string} text
 */
function capitalizeFirstLetter(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}


/**
 * Prevent leaving page without save
 * @param {string} formName Name of the form (e.g.: lessons, questionnaires)
 */
function preventLeavingPage(formName){
    // the variable's value must be 1 in case the user accidentally presses the 'back' or 'refresh' button on the browser
    var linkPressed = 1;

    // Resetting the value to 0
    // In case the user presses Logout button, Save button or Cancel button, this variable won't change later
    $("a").click(function(){
        linkPressed = 0;
    });

    // Pressing a link which is not one of them: Logout button, Save button, Cancel button
    // This will ask the user if he/she wants to leave
    $("a:not(#"+formName+"formcancel,#"+formName+"formsubmit,#logoutformsubmit,#"+formName+"formsubmitstay)").click(function(){
        linkPressed = 1;
    });

    // Before leaving page
    $(window).bind('beforeunload', function(){
        // If user presses a normal link, we try to prevent leaving the page
        if(linkPressed == 1){
            return stAdmin["LEAVE_AREYOUSURE"];
        }
    });
}

/**
 * This function format the simple SQL date time format to a formatted date time ()
 * @param {string} dateTimeString (YYYY-MM-DD HH:mm:ss)
 * @param {string} format (optional) default: YYYY.MM.DD HH:mm:ss
 */
function dateFormatter(dateTimeString, format)
{
    if(typeof format === "undefined"){
        format = "YYYY.MM.DD HH:mm:ss";
    }

    var datetime = moment(dateTimeString);
    return datetime.format(format)
}

/**
 * This function add animate css class to a element
 * @param {string} element
 * @param {string} animationName
 * @param {function} callback
 */
function animateCss(element, animationName, callback) {
    var node = document.querySelector(element);
    if(!node) return;

    node.classList.add('animated', animationName);

    function handleAnimationEnd() {
        node.classList.remove('animated', animationName);
        node.removeEventListener('animationend', handleAnimationEnd);

        if (typeof callback === 'function') callback();
    }

    node.addEventListener('animationend', handleAnimationEnd);
}

/**
 * Creates a passive event listener.
 * @param {JQuery} elem The target HTML element.
 * @param {string} event The event.
 * @param {function} fn The event handler function.
 */
function addPassiveEventListener(elem, event, fn) {
    var $elem = $(elem);
    if(!$elem.length) return;

    // Test via a getter in the options object to see if the passive property is accessed
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function() {
            supportsPassive = true;
            }
        });
        window.addEventListener('testPassive', null, opts);
        window.removeEventListener('testPassive', null, opts);
    } catch (e) {}

    // Use our detect's results. passive applied if supported, capture will be false either way.
    $elem.get(0).addEventListener(event, fn, supportsPassive ? { passive: true } : false);
}

String.prototype.capitalize = function() {
    return this[0].toUpperCase() + this.slice(1);
}

/**
 * This function makes array from string
 * @param {string} text
 */
function arrayFromString(text)
{
    var result = [];
    if((typeof(text)=='string' && text.length>0) || typeof(text)=='number' ) {
        result = text.toString().split(',');
    }
    return result;
}

/**
 * This function is add new line from pattern to the main div.
 * @param {string} divID
 * @param {array} inputFields
 */
function addNewInlineFields(divID, inputFields){

    var counter = $(event.target).closest('.custom-costs').find('.inline-counter');
    var pattern = $(event.target).closest('.custom-costs').find('.inline-pattern');
    var container = $(event.target).closest('.custom-costs').find('.custom-costs-container');
    var inlineIDS = $(event.target).closest('.custom-costs').find('.inline-ids');

    var actcount = parseInt($(counter).val());
    var newcount = actcount+1;
    $(counter).val(newcount);

    var html = $(pattern).html();
    var newhtml = html.split('###').join(newcount);
    $(container).append(newhtml);
    $(".custom-costs-line-"+newcount).slideDown("fast");

    $.each(inputFields, function(inputID, inputType) {
        switch(inputType) {
            case "selectpicker":
                $("#"+inputID+newcount).addClass("selectpicker");
                $("#"+inputID+newcount).selectpicker();
                break;
            case "toggle":
                $("#"+inputID+newcount).attr("type","checkbox");
                $("#"+inputID+newcount).bootstrapToggle();
                break;
            default:
                console.log("Hibás típus");
        }
    });

    var ids = $(inlineIDS).val();
    $(inlineIDS).val(ids+newcount+",");

}

/**
 * This function is remove the line from the main div.
 * @param {number} id
 * @param {string} divID
 */
function removeField(id,divID) {
    confirmDialog(stAdmin.REMOVEFIELD_DELETE_CONFIRM,stAdmin.DELETE_CONFIRM,stAdmin.CANCEL.capitalize(), function(){

        var inlineIDS = $('#'+divID).find('.inline-ids');

        var ids = $(inlineIDS).val();
        var newids = ids.replace(id+",","");
        $(inlineIDS).val(newids);
        $("#"+divID+" .custom-costs-line-"+id).slideUp(function() {
            $("#"+divID+" .custom-costs-line-"+id).remove();
        });
    });
}


/**
 * This function is fired when click to a copy from element copy button
 * @param {string} element
 */
function SelectText(element)
{
    var doc = document;
    var text = doc.getElementById(element);
    var range;
    var selection;
    if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(text);
        range.select();
    } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(text);
        selection.removeAllRanges();
        selection.addRange(range);
    }
}

var maskType;
var areaCode = ["20", "30", "31", "50", "70"];
/**
 * This function is get the input field datas and set the correct mask.
 * @param {object} inputField Form input field
 */
function checkMask(inputField) {
    fieldID = $(inputField).attr('id');
    phonenumber = $("#"+fieldID).val().replace(/\D/g,'');
    var thirdChar = phonenumber.charAt(2);
    var area = phonenumber.substr(2, 2);
    setMask(fieldID, area, thirdChar);
}

/**
 * This function is set the correct mask to the input field.
 * @param {String} fieldID
 * @param {int} area
 * @param {int} thirdChar
 */
function setMask(fieldID, area, thirdChar) {
    if(thirdChar == "1" && maskType != "budapest"){
        $("#"+fieldID).mask("?99-9-9999999",{placeholder:"__-_-_______"}).attr("placeholder","__-_-_______");
        maskType = "budapest";
    }
    if(thirdChar != "1" && jQuery.inArray(area, areaCode) !== -1 && maskType != "mobil"){
        $("#"+fieldID).mask("?99-99-9999999",{placeholder:"__-__-_______"}).attr("placeholder","__-__-_______");
        maskType = "mobil";
    }
    if(thirdChar != "1" && jQuery.inArray(area, areaCode) === -1 && maskType != "phone"){
        $("#"+fieldID).mask("?99-99-999999",{placeholder:"__-__-______"}).attr("placeholder","__-__-______");
        maskType = "phone";
    }
}

/**
 * Creates a formatted time from seconds (between 0:00:00 and 23:59:59)
 * @param {number}  seconds - The seconds
 * @param {boolean} [includeSeconds] - Whether to include seconds
 * @return {string} The formatted time or null.
 */
function formatTimeFromSeconds(seconds, includeSeconds) {
    var result = null;
    var h, m, s;
    if(isFinite(seconds) && seconds > 0) {
        if(typeof includeSeconds === 'undefined') includeSeconds = true;
        var dayInSeconds = 86400;
        if(seconds < dayInSeconds) {
            h = Math.floor(seconds / 3600);
            m = Math.floor((seconds - h * 3600) / 60);

            result = h + ':' + m.toString().padStart(2, '0');

            if(includeSeconds) {
                s = Math.floor(seconds - h * 3600 - m * 60);
                result += ':' + s.toString().padStart(2, '0');
            }
                ;
        } else {
            result = includeSeconds ? '23:59:59' : '23:59';
        }
    }

    return result;
}
/**
 * Initializes a DataTable.
 * Debounces quick search.
 * Applies quick search only to visible columns.
 *
 * Usage:
 *     Replace datatable initialization
 *         var table = $('#datatable').DataTable({...options...});
 *     with
 *         var table = initDataTable('#datatable', {...options...});
 *
 * Original ideas:
 *     https://datatables.net/forums/discussion/45016/how-to-search-only-visible-columns
 *     https://datatables.net/forums/discussion/comment/66906/#Comment_66906
 *
 * @param {string|JQuery} selector         JQuery selector.
 * @param {object}        options          DataTable options.
 * @param {int}           debounceTimeout  (optional) Quick search debounce timeout. Default: 700ms.
 * @return {object} The DataTable object.
 */
function initDataTable(selector, options, timeout) {

    var dtOptions = $.extend({}, options, {initComplete: onInitComplete});
    var dtSearchableDefaults = getSearchableDefaults();
    var searchTimeout = null;
    var prevSearchVal = null;
    var prevSearchableCols = null;

    var dt = $(selector).DataTable(dtOptions);
    prevSearchableCols = updateSearchableProperties();
    dt.on('column-visibility.dt', debounceDataTableQuickSearch);

    dt.on('preXhr.dt', function ( e, settings, data ) {
        var columnsVisibleStr = '';
        var columnsVisibleArr = dt.columns().visible();
        columnsVisibleArr = $.map(columnsVisibleArr, function(isVisible){ return isVisible ? 1 : 0; });
        columnsVisibleStr = columnsVisibleArr.join('');

        data.colVisibility = columnsVisibleStr;
    });

    return dt;

    // ----------------------------------

    function getSearchableDefaults() {
        var searchable = $(selector).find('th').map(function(){return true;});
        $.each(dtOptions.columnDefs, function(index, colDef) {
            if(colDef.hasOwnProperty('searchable') && colDef.hasOwnProperty('targets')) {
                var targets = colDef.targets;
                if(!$.isArray(targets)) targets = [targets];
                $.each(targets, function(index, colIndex) {
                    if(typeof console.assert === 'function') console.assert(isFinite(colIndex), 'colIndex must be a finite number. Found: ' + colIndex);
                    searchable[colIndex] = colDef.searchable;
                });
            }
        });
        return searchable;
    }

    function onInitComplete(settings, json) {
        var $input = $('div.dataTables_filter input');
        prevSearchVal = $input.val();

        $input
        .off('keyup.DT input.DT')
        .on('keyup', debounceDataTableQuickSearch);

        if(typeof options.initComplete === 'function') options.initComplete(settings, json);
    }

    function debounceDataTableQuickSearch() {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(searchVisibleColumns, timeout || 700);
    }

    function searchVisibleColumns() {
        var searchVal = $('div.dataTables_filter input').val();
        if (searchVal == null) return;

        var currentSearchableCols = updateSearchableProperties();

        if(searchVal == prevSearchVal && currentSearchableCols == prevSearchableCols) return;

        prevSearchVal = searchVal;
        prevSearchableCols = currentSearchableCols;

        dt.search(searchVal, false, true, true).draw();
    }

    function updateSearchableProperties() {
        var result = '';
        var visibleColumns = dt.columns().visible();
        var settings = dt.settings()[0];

        $.each(visibleColumns, function(index, isVisible) {
            var isSearchable = isVisible && dtSearchableDefaults[index];
            settings.aoColumns[index].bSearchable = isSearchable;
            result += isSearchable ? '1':'0';
        });

        return result;
    }
}

/**
 *
 * @param {object} DTable Initialised DataTable
 */
function initDataTableSearchField(DTable) {
    $('.dt-search').on( 'click', function(e) {
        e.stopPropagation();
        e.preventDefault();
    });
    $('.glyphicon-remove').on( 'click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        $(this).closest(".dt-search-container").find(".dt-search").val("").keyup();
        $(this).closest("th").blur();
    });

    $('.dt-search').on( 'keyup', function(e) {
        if($(this).val() == "") {
            $(this).closest(".dt-search-container").find(".glyphicon-search").removeClass("hide");
            $(this).closest(".dt-search-container").find(".glyphicon-remove").addClass("hide");
        } else {
            $(this).closest(".dt-search-container").find(".glyphicon-search").addClass("hide");
            $(this).closest(".dt-search-container").find(".glyphicon-remove").removeClass("hide");
        }
    });

    $('body').on('DOMNodeInserted', '.ColVis_collection', function () {
        $(".ColVis_collection .dt-search-container").remove();
    });

    $('body').on('DOMNodeInserted', '#datatable th', function () {
        var currentSearch = DTable.columns().search();
        var colId = $(this).find(".dt-search").attr("data-colnum");

        $(this).find(".dt-search").val(currentSearch[colId]);

        if(currentSearch[colId] == "") {
            $(this).find(".glyphicon-search").removeClass("hide");
            $(this).find(".glyphicon-remove").addClass("hide");
        } else {
            $(this).find(".glyphicon-search").addClass("hide");
            $(this).find(".glyphicon-remove").removeClass("hide");
        }

        $("#datatable_filter").addClass("hide");
    });
}

/**
 * Can be triggerd when an element height is changed
 *
 * @param {DOM} elm
 * @param {function} callback
 */
function onElementHeightChange(elm, callback)
{
    var lastHeight = elm.clientHeight, newHeight;
    (function run(){
        newHeight = elm.clientHeight;
        if( lastHeight != newHeight )
            callback();
        lastHeight = newHeight;

        if( elm.onElementHeightChangeTimer )
            clearTimeout(elm.onElementHeightChangeTimer);

        elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
}

/**
 * Append elements to a duallist
 * @param {string} list The name of the list in the DOM
 * @param {array} datas [
 *                          {
 *                              publics:1|0, (optional)
 *                              id:mixed
 *                              name: string
 *                              item_id: int (if contain any value it will be added to the selected list)
 *                          },
 *                          ...
 *                      ]
 */
function appendToDualList(list, datas)
{
    var selected = [];
    $.each(datas, function (i, data) {
        if(data.item_id){
            appendToList('selected', data);
        } else {
            appendToList('notselected', data);
        }
    });

    function appendToList(option, row)
    {
        var listContainer = "#ul" + option + list;
        var input = "#"+option + list;
        var icon = row.hasOwnProperty('publics') ? '<img src="'+ root +'images/icon'+row.publics+'.png" alt="" style="width: 16px;"> ' : '';
        var li = $('<li class="list-group-item" data="' + row.id + '">' + icon + row.name + '</li>');
        $(listContainer).append(li);

        if(option === 'selected'){
            selected.push(row.id)
            $(input).val(selected.join(','));
        }
    }
}

/**
 * Select element in a duallist
 * @param {string} list
 * @param {mixed} data
 */
function selectInDualList(list, data)
{
    var selectedIds = $('#selected'+list).val();
    if(selectedIds){
        selectedIds = selectedIds.split(',');
        //check if already selected
        if(selectedIds.indexOf(data) !==-1) return;
    }
    var listElements = $('#ulnotselected'+list+ ' li');
    var newElementIDs = [];
    $.each(listElements, function (i, element) {
        if($(element).attr('data') == data){
            $(element).clone().appendTo('#ulselected'+list)
            $(element).detach()
            newElementIDs.push(data)
        }
    });

    if(selectedIds){
        newElementIDs = selectedIds.concat(newElementIDs)
    }

    $('#selected'+list).val(newElementIDs.join(','))
}


/**
 * Get the current date (format: YYYY_MM_DD_HH_mm)
 */
function getCurrentDate() {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        minutes = d.getMinutes();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day, hour, minutes].join('_');
}

/**
 * Returns a list of CSS classes for the table/row/cell classes list.
 * @param {string|string[]} cssPrefix  - The prefix
 * @param {StyleSheetList} styleSheets - (optional) The HTML Document StyleSheetList instance.
 * @return {array}
 */
function getWebhtmlTableClassDropDownItems(cssPrefix, styleSheets) {
    var items = getWebhtmlTableCssClasses(cssPrefix, styleSheets);
    items.splice(0, 0, {title: '...', value: ''});
    return items;
}

/**
 * Get stlyes from stylesheets by selector prefix.
 * Returns an array of {title, value} objects.
 * @param {string|string[]} cssPrefix  - The prefix
 * @param {StyleSheetList} styleSheets - (optional) The HTML Document StyleSheetList instance.
 * @return {array}
 */
function getWebhtmlTableCssClasses(cssPrefix, styleSheets) {
    if(!cssPrefix) {
        console.error('Missing cssPrefix');
        return [];
    }

    styleSheets = styleSheets || document.styleSheets;

    if(!$.isArray(cssPrefix)) cssPrefix = [cssPrefix];
    var prefixQuery = cssPrefix.map(function(s){ return regexpEscape(s); }).join('|');

    var obj = {};
    var arr = [];
    // Note: No "g" flag here, it makes the regex stateful.
    var re = new RegExp("("+prefixQuery+")([\\w\\d-_]+)");

    $.each(styleSheets, function(i,v) {
        if(v.href && !v.href.startsWith(root)) return;
        var rules = v.rules || v.cssRules;
        $.each(rules, function(e,f) {
            if(!f.selectorText) return;

            var match = re.exec(f.selectorText);
            var cssName = match && match.length >= 3 && match[2];
            if(cssName && obj[cssName] == null) {
                obj[cssName] = 1;
                var cssClass = match[0].substr(match[0].lastIndexOf('.') + 1);
                arr.push({title: getWebhtmlTableCssNameToTitle(cssName), value: cssClass});
            }
        });

    });

    return arr;
}

/**
 * Converts CSS name to title, by convering camelCase to Title Case
 * and replacing underscores (_) and dashes (-) with spaces.
 * @param {string} cssName  The css name.
 * @return {string}
 */
function getWebhtmlTableCssNameToTitle(cssName) {
    var title = camelToTitleCase(cssName)
        .replace(/[_-]/g, ' ')
        .replace(/ +/g, ' ')
        .trim();

    return title.length ? title : '_';
}

/**
 * Converts camelCaseString to Title Case String.
 * @param {string} str
 * @return {string}
 */
function camelToTitleCase(str) {
    return str
        .replace(/[0-9]{2,}/g, function(match) {return ' ' + match + ' '; })
        .replace(/[^A-Z0-9][A-Z]/g, function(match) { return match[0] + ' ' + match[1]; })
        .replace(/[A-Z][A-Z][^A-Z0-9]/g, function(match) { return match[0] + ' ' + match[1] + match[2]; })
        .replace(/[ ]{2,}/g, function(match) { return ' '; })
        .replace(/\s./g, function(match) { return match.toUpperCase(); })
        .replace(/^./, function(match) {return match.toUpperCase(); })
        .trim();
}

/**
 * Open new window for send email, systemlettersend admin menu
 * @param {object} recipients {users: [...], usergroups: [...], organisation: [...]}
 */
function openSendemailWindow(recipients)
{
    if (recipients.hasOwnProperty('users') && recipients.users.length == 0) {
       return  alertDialog(stAdmin.NOSELECTEDDATA);
    } else if(recipients.hasOwnProperty('usergroups') && recipients.usergroups.length == 0){
        return  alertDialog(stAdmin.NOSELECTEDDATA);
    } else if(recipients.hasOwnProperty('organisations') && recipients.organisations.length == 0){
        return  alertDialog(stAdmin.NOSELECTEDDATA);
    }

    var getParam = '';
    if(recipients.hasOwnProperty('users')){
        getParam += getParam ? '&' : '';
        getParam += 'userIds='+recipients.users.join(',');
    }
    if(recipients.hasOwnProperty('usergroups')){
        getParam += getParam ? '&' : '';
        getParam += 'userGroupIds='+recipients.usergroups.join(',');
    }
    if(recipients.hasOwnProperty('organisations')){
        getParam += getParam ? '&' : '';
        getParam += 'organisationIds='+recipients.organisations.join(',');
    }

    window.open(root+'admin/systemletterssend/insert?'+getParam);
}

/**
 * Put a loading icon between the form input and the label
 * @param {string} formInputID
 */
function formInputProgressStart(formInputID)
{
    if(formInputID){
        var formInput = $('*[for="'+formInputID+'"]').closest('.label-div')
        formInput.append('<img src="'+root+'images/loading.gif" class="loading-img" widt="16" height="16" alt="loading">');
    }
}

/**
 * Detach the loading icon before the form input
 * @param {string} formInputID
 */
function formInputProgressEnd(formInputID)
{
    if(formInputID){
        var formInput = $('*[for="'+formInputID+'"]').closest('.label-div')
        formInput.find('.loading-img').detach()
    }
}

/**
 * String.padEnd() polyfill
 * version 1.0.1
 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge
 * Basic support	57   	48      (No)	            44   	10      15
 * -------------------------------------------------------------------------------
 * @see https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
 */
if (!String.prototype.padEnd) {
    String.prototype.padEnd = function padEnd(targetLength, padString) {
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length > targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return String(this) + padString.slice(0, targetLength);
        }
    };
}

/**
 * String.padStart() polyfill
 * version 1.0.1
 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge
 * Basic support	57   	51      (No)	            44   	10      15
 * -------------------------------------------------------------------------------
 * @see https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
 */
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length > targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
}

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 * @param {function} func        The function to debounce.
 * @param {number}   wait        The wait time in ms.
 * @param {boolean}  [immediate] If passed, trigger the function on the leading edge, instead of the trailing.
 */
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

/**
 * Change image on the imagepreview_interactive on forms
 *
 * @param {string} inputId Input's ID
 * @param {string} inputVal Input's value (image's path e.g.: media/image.png)
 */
function changePreviewImage(inputId,inputVal){
    if(inputVal == ""){
        $(".form-group #imagepreviewDiv > .preview_"+inputId+".imagepreview_interactive_text").show();
        $(".form-group #imagepreviewDiv > .preview_"+inputId+".imagepreview_interactive_image").hide();
    } else {
        $(".form-group #imagepreviewDiv > .preview_"+inputId+".imagepreview_interactive_text").hide();
        $(".form-group #imagepreviewDiv > .preview_"+inputId+".imagepreview_interactive_image").show();
    }

    $(".form-group #imagepreviewDiv > .preview_"+inputId+".imagepreview_interactive_image").css("background-image","url('"+root+inputVal+"')");
}